<template>
	<div class="page page-product-creator p-0">
		<!-- Header -->
		<div class="page-header hidden">
			<div class="container">
				<nav
					class="pc-steps nav nav-justified"
					v-if="!isEditProduct && !isStepActive('done')"
				>
					<button
						type="button"
						class="pc-step nav-item nav-link"
						:class="[
							{ active: isStepActive('product') },
							{ hidden: productId },
						]"
						:disabled="productId"
						@click="changeStep('product')"
					>
						{{ $t('pc.step.product') }}
					</button>
				</nav>
			</div>
		</div>

		<!-- Content -->
		<div class="page-content container mt-5" v-if="isProductReady">
			<h1 class="page-title" v-if="isEditProduct || isEditForm">
				<router-link :to="backUrl.path" v-if="isEditProduct"
					><i class="material-icons">chevron_left</i></router-link
				>
				<router-link
					:to="{ name: 'productDetails', params: { id: productId } }"
					v-if="isEditForm"
					><i class="material-icons">chevron_left</i></router-link
				>
				<span
					>{{ productDetails.name }}
					<span v-if="isEditForm && formDetails"
						>- {{ formDetails.name }}</span
					></span
				>
			</h1>
			<div class="row">
				<!-- Main -->
				<div class="col-sm-12 col-lg-10 offset-lg-1">
					<!-- Step Product -->
					<div
						class="pc-section pc-section-product"
						v-if="isStepActive('product')"
					>
						<!-- Errors -->
						<errors :errors="productErrors" id="step-errors"> </errors>

						<div class="alert alert-danger" role="alert" v-if="product.status === 'suspended'">
							<b>Produk Ditangguhkan</b>
							<div>
								{{ getProductSuspendNote }}
							</div>
						</div>

						<div class="pc-images pc-box box" id="images" v-if="isAdmin">
							<div class="box__title">
								<span class="box__icon fi fi-rr-circle-user"></span
								><b>Supplier</b>
								<div class="spinner-grow spinner-grow-sm ml-2" role="status" v-if="isSearchSupplier">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
							<!-- <select-supplier
								:is-error="isFieldError('product', 'supplier')"
								:is-edit="isEditProduct"
								:product="product"
								@change="onSupplierChange">
							</select-supplier> -->
							<multiselect
								v-model="selectedSupplier"
								class="orders-status-list multiselect-auto-width form-control"
								:class="{ 'error': isFieldError('product', 'supplier') }"
								placeholder="Select Supplier (Name - Email)" track-by="email" label="label"
								:options="supplierOptions"
								:show-labels="false"
								:disabled="isEditProduct"
								:allow-empty="false"
								:multiple="false"
								@select="onSupplierChange"
								@search-change="fetchDataSupplier"
							>
								<span slot="noResult">{{ $t('No Supplier found') }}</span>
								<span slot="noOptions">
									Type Supplier name or email ...
								</span>
							</multiselect>
							<small v-if="isFieldError('product', 'supplier')" class="text-danger">Supplier cannot be empty</small>
						</div>

						<!-- Errors List -->
						<!-- <errors-list
							:errors="productErrorsList"
							id="step-errors">
						</errors-list> -->
						<!-- Images -->
						<div class="pc-images pc-box box" id="images">
							<div class="box__title">
								<!-- <span class="box__icon icon icon-image-orange"></span>Images -->
								<span class="box__icon fi fi-rr-picture"></span
								><b>Upload Produk</b>
							</div>
							<div class="row">
								<div class="col-sm-4">
									<h5 class="pc-heading"><b>Foto Produk</b></h5>
									<p class="pc-p">
										Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px
										(Untuk gambar optimal gunakan ukuran minimum 700 x 700 px).
										Pilih foto produk atau tarik dan letakkan hingga {{ productImagesLimit }} foto
										sekaligus di sini. Cantumkan min. 3 foto yang menarik agar
										produk semakin menarik pembeli.
									</p>
								</div>
								<div class="col-sm-8">
									<div class="box__content">
										<div class="pc-images-list">
											<draggable
												draggable=".draggable"
												v-model="product.images"
												v-bind="dragOptions"
												@start="drag = true"
												@end="drag = false"
											>
												<transition-group
													class="upload-image-container"
													type="transition"
													:name="!drag ? 'flip-list' : null"
												>
													<div
														class="image-wrapper"
														:class="{ draggable: image !== '' }"
														v-for="(image, index) in product.images"
														:key="index + 0"
													>
														<div
															v-if="isLoading[index] && image === ''"
															class="pc-image-empty"
														>
															<div class="image-loading">
																<div class="is-loading"></div>
															</div>
														</div>
														<div
															v-else-if="image === ''"
															class="pc-image-empty cursor-pointer h-100"
															@click="uploadImages(index)"
															@dragover.prevent="handleDragOver"
															@dragenter.prevent="handleDragEnter"
															@dragleave.prevent="handleDragLeave"
															@drop.prevent="(event) => handleDrop(event, index)"
														>
															<div class="image-upload-placeholder">
																<i
																	class="fi fi-rr-picture image-placeholder"
																></i>
																<div class="text-placeholder">
																	Foto {{ index + 1 }}
																</div>
															</div>
														</div>
														<div
															v-else
															class="pc-image h-100"
															:class="{
																'is-loading': image === '',
															}"
														>
															<div
																class="img"
																:style="{ backgroundImage: `url('${image}')` }"
															></div>
															<i
																class="material-icons"
																v-tooltip="'Remove'"
																@click="removeProductImages(index)"
																>close</i
															>
														</div>
													</div>
												</transition-group>
											</draggable>
										</div>
										<div class="form-group buttons m-0 hidden">
											<input
												type="file"
												:accept="['image/jpeg', 'image/png']"
												class="input-file"
												ref="imageUploader"
												id="pc-product-images-file"
												@change="onProductImagesChange"
											/>
											<label
												for="pc-product-images-file"
												class="btn btn-primary"
												:class="{ 'is-loading': product.isUploading }"
												>Upload images</label
											>
											<div class="pc-input-desc">
												You can choose to show or hide product images on
												Checkout Page section
											</div>
										</div>
										<div class="form-group buttons m-0 hidden">
											<input
												type="file"
												class="input-file"
												ref="fileUploader"
												id="pc-product-images-file"
												@change="onFileChange"
											/>
											<label
												for="pc-product-images-file"
												class="btn btn-primary"
												:class="{ 'is-loading': product.isUploading }"
												>Upload images</label
											>
											<div class="pc-input-desc">
												You can choose to show or hide product images on
												Checkout Page section
											</div>
										</div>
										<!-- <div class="form-group m-0" v-if="product.images.length > 0">
								<label>
									<input type="checkbox" class="input-checkbox input-checkbox-large" v-model="product.imageEnabled">
									<span></span>
									<span class="input-checkbox-text">Show product images on checkout page?</span>
								</label>
							</div> -->
									</div>
								</div>
							</div>
							<!-- Vidio Produk -->
							<div class="row mb-2">
								<div class="col-sm-4">
									<h5 class="pc-heading"><b>Vidio Produk</b></h5>
									<p class="pc-p">
										Isian berupa url vidio youtube. Masukan vidio yang
										menjelaskan produk agar pembeli semakin tertarik.
									</p>
								</div>
								<div class="col-sm-8">
									<!-- Name -->
									<div class="form-group mb-1">
										<input
											type="text"
											class="input form-control"
											:class="{ error: isFieldError('product', 'videos') }"
											v-model.trim="product.videos[0]"
										/>
									</div>
								</div>
							</div>
						</div>

						<!-- Description -->
						<div class="pc-options pc-box box" id="general">
							<div class="box__title">
								<i class="box__icon fi fi-rr-settings-sliders"></i>Informasi
								Produk
							</div>
							<div class="box__content">
								<!-- Nama Produk -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading"><b>Nama Produk</b></h5>
										<p class="pc-p">
											Cantumkan min. 40 karakter agar semakin menarik dan mudah
											ditemukan oleh pembeli, terdiri dari jenis produk, merek,
											dan keterangan seperti warna, bahan, atau tipe.
										</p>
									</div>
									<div class="col-sm-8">
										<!-- Name -->
										<div class="form-group mb-1">
											<input
												type="text"
												class="input form-control"
												:class="{ error: isFieldError('product', 'name') }"
												@change="onProductNameChange"
												v-model.trim="product.name"
											/>
											<p class="error-messages" v-if="isFieldError('product','name')">{{ getErrorMessage('product', 'name') }}</p>
										</div>
									</div>
								</div>
								<!-- Code / SKU-->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">SKU (Stock Keeping Unit)</h5>
										<p class="pc-p">
											Gunakan kode unik SKU jika kamu ingin menandai produkmu.
										</p>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<input
												type="text"
												class="input form-control input-small"
												:class="{ error: isFieldError('product', 'code') }"
												v-model.trim="product.code"
											/>
											<p class="error-messages" v-if="isFieldError('product','code')">{{ getErrorMessage('product', 'code') }}</p>
											<div class="pc-input-desc">
												Example: product code for "Kelambu Anak Bayi" is KAB
											</div>
										</div>
									</div>
								</div>
								<!-- Category -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Kategori</h5>
									</div>
									<div class="col-sm-8">
										<product-category
											:data="product.category"
											:label="false"
											@change="onCategoryChange"
											:error="isFieldError('product', 'category')"
										>
										</product-category>
									</div>
								</div>

								<!-- Collections -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Koleksi</h5>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<multiselect
												track-by="_id"
												label="name"
												:placeholder="'Input or select collection'"
												:options="collections"
												:hide-selected="true"
												:multiple="true"
												:taggable="true"
												:show-labels="false"
												:close-on-select="false"
												tag-placeholder="Press enter to insert collection"
												tag-position="bottom"
												@tag="addCollection"
												v-model="productCollections"
											>
											</multiselect>
										</div>
									</div>
								</div>
								<!-- Deskripsi Produk -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading"><b>Deskripsi Produk</b></h5>
										<p class="pc-p">Penjelesan lebih detail tentang produk.</p>
									</div>
									<div class="col-sm-8">
										<!-- Deskripsi -->
										<div class="form-group mb-1">
											<content-editor v-model="product.description">
											</content-editor>
										</div>
									</div>
								</div>
								<!-- Status -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">
											<b>Status Produk</b>
											<i
												class="material-icons info"
												v-tooltip="
													'<div class=\'order-status-tooltip text-left\'><div><b>Archived</b>: Produk tidak akan tampil di halaman depan & pencarian.</div><div><b>Verification</b>: Produk menunggu proses verifikasi tim ostock.</div><div><b>Live</b>: Produk tampil di halaman depan dan dapat ditambahkan oleh seller.</div></div>'
												"
												>info</i
											>
										</h5>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<div
												class="btn-group btn-group-toggle btn-group-block"
												role="group"
											>
													<button
															type="button"
															class="btn btn-default col"
															:class="{ active: product.status === 'disabled' }"
															@click="changeProductStatus('disabled')"
														>
															Archived
													</button>
													<!-- <button
														type="button"
														class="btn btn-default col"
														:class="{ active: product.status === 'test' }"
														@click="changeProductStatus('test')"
													>
														Test Mode
													</button> -->
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: product.status === 'request' || product.status === 'pricing' || product.status === 'recontent' || product.status === 'landing_page' }"
														@click="changeProductStatus('request')"
													>
														Verification
													</button>
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: product.status === 'live' }"
														@click="changeProductStatus('live')"
														:disabled="!(isAdmin && isEditProduct)"
													>
														Live
													</button>
												</div>
											</div>
										</div>
									</div>

							</div>
						</div>

						<!-- Pricing -->
						<div class="pc-pricing pc-box box" id="pricing">
							<div class="box__title">
								<!-- <span class="box__icon icon icon-pricing-orange"></span>Pricing -->
								<i class="box__icon fi fi-rr-label"></i> Harga
							</div>
							<div class="box__content">
								<!-- Komisi Ostock | Hidden by request -->
								<div class="row mb-2 hidden">
									<div class="col-sm-4">
										<h5 class="pc-heading"><b>Komisi Ostock</b></h5>
										<p class="pc-p">
											Komisi ostock adalah biaya penanganan untuk ostock.
											Secara default komisi nya adalah 5%, tetapi bisa dirubah
											presentase nya.
										</p>
									</div>
									<div class="col-sm-8">
										<div class="d-flex">
											<button
												v-if="openCommission === false"
												class="btn btn-default"
												@click="openCommission = true"
											>
												Ubah Komisi
											</button>
											<div
												class="mt-2 text-info ml-4"
												v-if="openCommission === false"
											>
												Komisi saat ini ({{ product.commission_percentage }}%)
												per pcs
											</div>
										</div>
										<div class="row mb-4" v-if="openCommission">
											<div class="col-sm-3">
												<div class="form-group mb-1">
													<div class="input-group d-flex align-items-center">
														<price-input
															class="input form-control"
															placeholder="Masukan Persentase"
															@input="checkCommisionPecentage"
															@change="checkCommisionPecentage"
															min="5"
															max="100"
															v-model="product.commission_percentage"
														></price-input>
														<div class="input-group-append">
															<div class="input-group-text">%</div>
														</div>
													</div>
												</div>
											</div>
											<div class="col-sm-2">
												<div class="form-group mb-1">
													<button
														class="btn btn-primary btn-block"
														v-tooltip="'Simpan Perubahan Komisi'"
														@click="openCommission = false"
													>
														Simpan
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- Product Type -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Variasi Produk</h5>
										<p class="pc-p">
											Pilih tab 'Simple' jika anda hanya memiliki 1 variasi
											produk dan pilih tab 'Variant' jika anda menggunakan
											beberapa variasi produk
										</p>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<div
												class="btn-group btn-group-toggle btn-group-block"
												role="group"
											>
												<button
													type="button"
													class="btn btn-default col"
													:class="{ active: product.type === 'simple' }"
													@click="changeProductType('simple')"
												>
													Simple
												</button>
												<button
													type="button"
													class="btn btn-default col"
													:class="{ active: product.type === 'variable' }"
													@click="changeProductType('variable')"
												>
													Variant
												</button>
											</div>
										</div>

										<!-- <div class="alert alert-info" role="alert">
											Biaya penanganan sebesar:
											{{ formatMoney(commissionFee) }} ({{ commission }}%) per
											pcs
										</div> -->

										<!-- Simple Pricing -->
										<div
											class="pc-pricing-simple"
											v-if="product.type === 'simple'"
										>
											<div class="row flex-start">
												<div class="col-xl-6">
													<!-- Harga Seller -> Harga Produk | Changed by request -->
													<div class="form-group mb-3">
														<label>Harga Produk</label>
														<div class="input-group mb-3">
															<div class="input-group-prepend">
																<div class="input-group-text">
																	{{ currencySymbol }}
																</div>
															</div>
															<input
																type="text"
																class="input form-control"
																min="0"
																:class="{ 'error is-invalid': isFieldError('product', 'price') }"
																@input="onPriceChange"
																@change="onPriceChanges"
																v-model="product.price"
															/>
															<div class="invalid-feedback" v-if="isFieldError('product','price')">
																{{ getErrorMessage('product', 'price') }}
															</div>
														</div>
													</div>
												</div>
												<div class="col-xl-6">
													<label>Additional PCS Information</label> <i class="material-icons info" v-tooltip="'Jika produk berupa paket bundling, masukan jumlah item'">info</i>
													<div class="input-group mb-3">
														<input type="text" class="input form-control" min="1" v-model.number="product.uom.value" @change="onUomChange">
														<div class="input-group-append"><div class="input-group-text">PCS</div></div>
													</div>
												</div>
											</div>

											<!-- Harga Supplier ke Ostock | Hidden by request -->
											<div class="form-group mb-3 hidden">
												<label
													><span>Harga Supplier ke Ostock</span>
													<!-- <span class="optional">(optional)</span>
													<i
														class="material-icons info"
														v-tooltip="'Cost of Goods Sold / Harga Pokok'"
														>info</i
													> -->
												</label>
												<div class="input-group">
													<div class="input-group-prepend">
														<div class="input-group-text">
															{{ currencySymbol }}
														</div>
													</div>
													<input
														type="text"
														class="input form-control"
														min="0"
														v-model="product.cogs"
														readonly
													/>
													<!-- <price-input
														class="input form-control"
														min="0"
														v-model="product.cogs"
													></price-input> -->
												</div>
											</div>

											<!-- Wholesale -->
											<!-- Disabled By Request -->
											<!-- <div class="form-group mb-2">
												<button
													type="button"
													class="btn btn-plain pl-0 text-primary"
													@click="addWholesale"
													v-if="product.wholesale.length === 0"
												>
													<span class="mr-2">+</span>{{ $t('Add') }} {{ $t('Wholesale Prices')}}
												</button>
												<button
													type="button"
													class="btn btn-plain pl-0 text-primary"
													@click="clearWholesale"
													v-if="product.wholesale.length > 0"
												>
													<span class="mr-2">-</span>
													<span>{{ $t('Remove')}} {{ $t('Wholesale Prices')}}</span>
												</button>
												<template v-if="product.wholesale.length > 0">
													<wholesale
														class="mt-3"
														:items="product.wholesale"
														:price="productPrice"
														:show-normal="false"
														v-bind:error.sync="isSimpleWholesaleError"
														@change="items => (product.wholesale = items)"
													>
													</wholesale>
												</template>
											</div> -->
										</div>

										<!-- Variable Pricing -->
										<div
											class="pc-pricing-variable"
											v-if="product.type === 'variable'"
										>
											<!-- Multiple Variations -->
											<div class="form-group">
												<div>
													<label><b>Multiple Variations</b></label>
												</div>
												<label>
													<input
														type="checkbox"
														class="input-checkbox input-checkbox-large"
														v-model="
															product.variations.multiple_variations.enabled
														"
													/>
													<span></span>
													<span class="input-checkbox-text"
														>Do you want to enable multiple variations
														order?</span
													>
												</label>
											</div>

											<product-attributes
												:default-weight="product.weight"
												:attributes="product.variations.attributes"
												:prices="product.variations.prices"
												:commission-percentage="product.commission_percentage"
												:outsource-commission="product.outsource_commission"
												:is-edit-product="isEditProduct"
												@change="onVariationPricesChange"
												:weight-variable-error="variationWeightError"
												:enabled-variable-error="variationEnabledError"
												@weight-changed="validateVariableWeight"
												@enabled-changed="validateVariableEnabled"
											>
											</product-attributes>
										</div>
									</div>
								</div>
								<!-- Komisi Seller | Hidden by request -->
								<div class="row mb-2 hidden">
									<div class="col-sm-4">
										<h5 class="pc-heading mt-2">Komisi Seller</h5>
										<p class="pc-p">
											Masukan margin / selisih harga dari harga jual yang akan
											diberikan bagi dropshiper.
										</p>
									</div>
									<div class="col-sm-8">
										<div class="row">
											<div class="col-md-6">
												<div class="form-group mb-2 mt-2">
													<select
														class="form-control"
														v-model="product.dropship.type"
													>
														<option value="percentage">Persentase</option>
														<option value="nominal">Nominal</option>
													</select>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group mb-3 mt-2">
													<div class="input-group d-flex align-items-center">
														<div class="input-group-prepend">
															<div
																v-if="product.dropship.type === 'nominal'"
																class="input-group-text"
															>
																{{ currencySymbol }}
															</div>
														</div>
														<price-input
															class="input form-control"
															min="0"
															v-model="product.dropship.margin"
														></price-input>
														<div class="input-group-append">
															<div
																v-if="product.dropship.type === 'percentage'"
																class="input-group-text"
															>
																%
															</div>
														</div>
														<i
															class="material-icons info ml-2"
															v-tooltip="
																'Margin adalah selisih dari harga produk dengan harga produk yang akan dipasarkan oleh seller'
															"
															>info</i
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- New Komisi Platform -->
								<div class="row mb-2 hidden">
									<div class="col-sm-4">
										<h5 class="pc-heading mt-2">Komisi Ostock</h5>
										<p class="pc-p">
											Masukan nilai komisi untuk platform.
										</p>
									</div>
									<div class="col-sm-8">
										<div class="row">
											<div class="col-md-6">
												<div class="form-group mb-2 mt-2">
													<select
														class="form-control"
														v-model="product.outsource_commission.type"
													>
														<option value="percentage">Persentase</option>
														<option value="nominal">Nominal</option>
													</select>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group mb-3 mt-2">
													<div class="input-group d-flex align-items-center">
														<div class="input-group-prepend" v-if="product.outsource_commission.type === 'nominal'">
															<div
																class="input-group-text"
															>
																{{ currencySymbol }}
															</div>
														</div>
														<price-input
															class="input form-control"
															min="0"
															v-model="product.outsource_commission.value"
														></price-input>
														<div class="input-group-append" v-if="product.outsource_commission.type === 'percentage'">
															<div
																class="input-group-text"
															>
																%
															</div>
														</div>
														<i
															class="material-icons info ml-2"
															v-tooltip="'Komisi Platform'"
															>info</i
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- Kode Unik | Hidden by request -->
								<div class="row mb-2 hidden">
									<div class="col-sm-4">
										<h5 class="pc-heading">Kode Unik</h5>
										<p class="pc-p">
											Atur kode unik saat pembayaran untuk memudahkan
											pembayaran/transfer bank
										</p>
									</div>
									<div class="col-sm-8">
										<div v-if="uniqueCode.enabled">
											<div class="form-group">
												<label>Type</label>
												<div
													class="btn-group btn-group-toggle btn-group-block"
													role="group"
												>
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: uniqueCode.type === 'decrease' }"
														@click="uniqueCode.type = 'decrease'"
													>
														<i class="material-icons hidden"
															>keyboard_arrow_down</i
														>Decrease
													</button>
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: uniqueCode.type === 'increase' }"
														@click="uniqueCode.type = 'increase'"
													>
														<i class="material-icons hidden"
															>keyboard_arrow_up</i
														>Increase
													</button>
												</div>
											</div>
											<div class="form-row">
												<div class="col">
													<label>Min</label>
													<input
														type="number"
														min="1"
														class="input form-control"
														v-model="uniqueCode.min"
													/>
												</div>
												<div class="col">
													<label>Max</label>
													<input
														type="number"
														min="1"
														class="input form-control"
														v-model="uniqueCode.max"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Wholesale Pricing -->
						<div
							class="pc-distributor pc-box box"
							id="distributor"
							v-if="isHasFeaturePrivateOrder"
						>
							<div class="box__title">
								<i class="box__icon fi fi-rr-label"></i> Harga Wholesale
							</div>
							<div class="box__content">
								<div class="row">
									<div class="col-sm-4">
										<h5 class="pc-heading">Atur Harga Wholesale</h5>
									</div>
									<div class="col-sm-8">
										<div class="row">
											<div class="col-md-12">
												<div class="form-group">
													<smart-toggle
														:info="'Hanya bisa diaktifkan untuk Produk Simple'"
														:disabled="product.type === 'variable'"
														v-model="isDistributorPriceEnabled"
														label="Aktifkan harga distributor?"
														@input="onChangeDistributorPrice"
													/>
												</div>
											</div>
										</div>

										<div class="row" v-if="isDistributorPriceEnabled">
											<div class="col-md-6">
												<div class="form-group mb-3">
													<label>Harga HPP Wholesale</label>
													<div class="input-group mb-3">
														<div class="input-group-prepend">
															<div class="input-group-text">
																{{ currencySymbol }}
															</div>
														</div>
														<input
															type="text"
															class="input form-control"
															min="0"
															:class="{ error: isFieldError('product', 'distributor_price') }"
															@input="onDistributorPriceChange"
															@change="onDistributorPriceChanges"
															v-model="distributor.price"
														/>
													</div>
													<p
														class="error-messages"
														v-if="isFieldError('product','distributor_price')"
													>
														{{ getErrorMessage('product', 'distributor_price') }}
													</p>
												</div>
											</div>

											<div class="col-md-6">
												<div class="form-group">
													<label>Stock Wholesale</label>
													<div class="input-group">
														<input
															type="text"
															min="0"
															class="input form-control"
															:class="{ error: isFieldError('product', 'distributor_stock') }"
															v-model="distributor.stock.quantity"
															:disabled="isEditProduct"
															@input="onDistributorStockChange"
														/>
														<div
															class="input-group-append"
															v-if="isEditProduct"
														>
															<button
																type="button"
																class="pc-stock-edit btn btn-default btn-icon"
																v-tooltip="'Adjust Stock'"
																@click="showAdjustStock(distributor.stock.quantity, null, 'wholesale')"
															>
																<i class="material-icons text-info">edit</i>
															</button>
															<button
																type="button"
																class="pc-stock-edit btn btn-default btn-icon"
																v-tooltip="'Reduce Stock'"
																@click="showReduceStock(null, 'wholesale')"
															>
																<i class="material-icons text-danger">remove</i>
															</button>
															<button
																type="button"
																class="pc-stock-edit btn btn-default btn-icon"
																v-tooltip="'Add Stock'"
																@click="showAddStock(null, 'wholesale')"
															>
																<i class="material-icons text-success">add</i>
															</button>
														</div>
													</div>
													<p
														class="error-messages"
														v-if="distributor.stock.quantity <= 0 && isFieldError('product','distributor_stock')"
													>
														{{ getErrorMessage('product', 'distributor_stock') }}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- New Inventory -->
						<div class="pc-bump pc-box box" id="inventory">
							<div class="box__title">
								<!-- <i class="material-icons box__icon icon">assignment</i>Inventory -->
								<i class="fi fi-rr-box box__icon"></i>Inventory
							</div>
							<div class="box__content">
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Stok Produk</h5>
									</div>
									<div class="col-sm-8">
										<!-- New Inventory -->
										<new-inventory-section
											:product="product"
											:is-edit-product="isEditProduct"
											:saved-product-id="tempProductId"
											@update="updateProductStock"
											v-if="product && isNewInventoryVisible"
										/>

										<!-- Old Inventory -->
										<div class="old-inventory-section" v-if="product && !isNewInventoryVisible">
											<div class="row">
												<div class="col-md-6">
													<div class="form-group mb-2">
														<label>
															<input
																type="checkbox"
																class="input-checkbox input-checkbox-large"
																v-model="product.stock.enabled"
																disabled
															/>
															<span></span>
															<span class="input-checkbox-text"
																>Enable Stock Management</span
															>
														</label>
													</div>
												</div>
												<div class="col-md-6 hidden">
													<div class="form-group mb-2">
														<label>
															<input
																type="checkbox"
																class="input-checkbox input-checkbox-large"
																v-model="product.stock.warehouse_enabled"
															/>
															<span></span>
															<span class="input-checkbox-text"
																>Enable Warehouse</span
															>
														</label>
													</div>
												</div>
											</div>
											<template v-if="product.stock.warehouse_enabled">
												<div class="form-group">
													<label><b>Warehouse</b></label>
													<multiselect v-model="selectedWarehouse" label="label"
														placeholder="Select Warehouse" :options="allWarehouse"
														@select="onWarehouseChange">
													</multiselect>
												</div>
											</template>
											<template v-if="product.stock.enabled">
												<!-- Variable Product's Stocks -->
												<div
													class="form-group"
													v-if="product.type === 'variable'"
												>
													<label><b>Stock Quantities</b></label>
													<div class="variable-item-stocks">
														<div
															class="variable-item-stock"
															v-for="(variation, index) in product.variations
																.prices"
															:key="index"
														>
															<div class="variable-item-stock-name">
																{{ variation.name.split('||').join(' - ') }}
															</div>
															<div>
																<div class="input-group">
																	<input
																		type="text"
																		class="input form-control"
																		:class="{
																			disabled:
																				isEditProduct &&
																				!isNewVariation(variation),
																			error: variation.stock.quantity < 0 && isFieldError('product', 'stock_variable')
																		}"
																		min="0"
																		v-model="variation.stock.quantity"
																		@input="onVariableStockChange(variation)"
																		:disabled="
																			isEditProduct && !isNewVariation(variation)
																		"
																	/>
																	<div
																		class="input-group-append"
																		v-if="
																			isEditProduct && !isNewVariation(variation)
																		"
																	>
																		<button
																			type="button"
																			class="pc-stock-edit btn btn-default btn-icon"
																			v-tooltip="'Adjust Stock'"
																			@click="
																				showAdjustStock(
																					variation.stock.quantity,
																					variation.name,
																				)
																			"
																		>
																			<i class="material-icons text-info">edit</i>
																		</button>
																		<button
																			type="button"
																			class="pc-stock-edit btn btn-default btn-icon"
																			v-tooltip="'Reduce Stock'"
																			@click="showReduceStock(variation.name)"
																		>
																			<i class="material-icons text-danger"
																				>remove</i
																			>
																		</button>
																		<button
																			type="button"
																			class="pc-stock-edit btn btn-default btn-icon"
																			v-tooltip="'Add Stock'"
																			@click="showAddStock(variation.name)"
																		>
																			<i class="material-icons text-success"
																				>add</i
																			>
																		</button>
																	</div>
																	<span class="error-messages" v-if="variation.stock.quantity < 0 && isFieldError('product', 'stock_variable')">{{ getErrorMessage('product', 'stock_variable') }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-sm-6" v-if="product.type === 'simple'">
														<div class="form-group">
															<label><b>Stock Quantity</b></label>
															<div class="input-group">
																<input
																	type="text"
																	min="0"
																	class="input form-control"
																	:class="{ error: isFieldError('product', 'stock_simple') }"
																	v-model="product.stock.quantity"
																	:disabled="isEditProduct"
																	@input="onStockChange"
																	/>
																<div
																	class="input-group-append"
																	v-if="isEditProduct"
																>
																	<button
																		type="button"
																		class="pc-stock-edit btn btn-default btn-icon"
																		v-tooltip="'Adjust Stock'"
																		@click="
																			showAdjustStock(product.stock.quantity)
																		"
																	>
																		<i class="material-icons text-info">edit</i>
																	</button>
																	<button
																		type="button"
																		class="pc-stock-edit btn btn-default btn-icon"
																		v-tooltip="'Reduce Stock'"
																		@click="showReduceStock()"
																	>
																		<i class="material-icons text-danger"
																			>remove</i
																		>
																	</button>
																	<button
																		type="button"
																		class="pc-stock-edit btn btn-default btn-icon"
																		v-tooltip="'Add Stock'"
																		@click="showAddStock()"
																	>
																		<i class="material-icons text-success">add</i>
																	</button>
																</div>
															</div>
															<p class="error-messages" v-if="product.stock.quantity <= 0 && isFieldError('product','stock_simple')">{{ getErrorMessage('product', 'stock_simple') }}</p>
														</div>
													</div>
													<div class="col-sm-6">
														<!-- Hidden by Request -->
														<div class="form-group hidden">
															<label>
																<b>Allow Backorders?</b>
																<i
																	class="material-icons info"
																	v-tooltip="
																		'Apabila di-allow, maka pembeli masih dapat memesan barang walaupun stock sudah habis.'
																	"
																	>info</i
																>
															</label>
															<select
																name="allow_backorder"
																class="form-control"
																v-model="product.stock.backorder"
															>
																<option :value="1">Allow</option>
																<option :value="0">Do not allow</option>
															</select>
														</div>
													</div>
												</div>
											</template>
											<template v-if="!product.stock.enabled">
												<div class="form-group">
													<label><b>Stock Status</b></label>
													<select
														name="stock_status"
														class="form-control"
														v-model="product.stock.status"
													>
														<option :value="1">In Stock</option>
														<option :value="0">Out of Stock</option>
													</select>
												</div>
											</template>
											<div class="form-group hidden">
												<label><b>Stock Visibility</b></label>
												<select
													name="stock_status"
													class="form-control"
													v-model="product.stock.visible"
												>
													<option :value="true">Visible</option>
													<option :value="false">Hide in checkout page</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Seller -->
						<div class="pc-bump pc-box box" id="inventory">
							<div class="box__title">
								<!-- <i class="material-icons box__icon icon">assignment</i>Inventory -->
								<i class="fi fi-rr-box box__icon"></i>Seller
							</div>
							<div class="box__content">
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Maksimum Seller</h5>
										<p class="pc-p">
											Masukan jumlah seller yang bisa menggunakan produk
											ini. fitur ini mengakomodir agar tidak terjadi penumpukan
											terlalu banyak pesanan
										</p>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<input
												type="number"
												class="form-control input"
												:class="{ warning: isLimited(product.dropship) }"
												v-model="product.dropship.max_dropshipper"
											/>
											<small
												class="text-warning"
												v-if="isLimited(product.dropship)"
												>Produk tidak muncul di pencarian karena telah mencapai
												limit seller. naikan limit seller anda untuk
												mengaktifkan kembali.</small
											>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Shipping -->
						<div class="pc-shipping pc-box box" id="shipping">
							<div class="box__title">
								<i class="material-icons box__icon icon">local_shipping</i>
								<span>{{ $t('Shipping') }}</span>
							</div>
							<div class="box__content">
								<div class="row mb-2" v-if="product.type === 'simple'">
									<div class="col-sm-4">
										<h5 class="pc-heading">Berat Produk (gram)</h5>
									</div>
									<div class="col-sm-8">
										<div class="form-group">
											<input
												type="number"
												class="form-control input"
												:class="{ error: isFieldError('product', 'weight') }"
												:disabled="product.type === 'variable'"
												v-model="product.weight"
												@change="onWeightChange"
											/>
											<p class="error-messages" v-if="isFieldError('product','weight')">{{ getErrorMessage('product', 'weight') }}</p>
										</div>
									</div>
								</div>
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Jenis Pengiriman</h5>
									</div>
									<div class="col-sm-8">
										<div class="row">
											<!-- <div class="col-md-6">
												<div class="form-group">
													<label>
														<input
															type="checkbox"
															class="input-checkbox input-checkbox-large"
															v-model="shipping.enabled"
														/>
														<span></span>
														<span class="input-checkbox-text"
															>Do you want to add shipping cost calculation?</span
														>
													</label>
												</div>
											</div> -->
											<div class="col-md-12">
												<div class="form-group">
													<smart-toggle
														v-model="isCODEnabled"
														label="Do you want to enable COD?"
														@input="onChangeEnableCOD"
													/>
												</div>
											</div>
										</div>
										<div v-if="shipping.enabled">
											<!-- Shipping Type -->
											<div class="form-group hidden">
												<label
													><b>{{ $t('Shipping Type') }}</b></label
												>
												<div
													class="btn-group btn-group-toggle btn-group-block"
													role="group"
												>
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: isShippingAutomated }"
														@click="changeShippingType('automated')"
													>
														Automated
													</button>
													<!-- <button
														type="button"
														class="btn btn-default col"
														:class="{ active: isShippingFlat }"
														@click="changeShippingType('flat')"
													>
														Flat
													</button>
													<button
														type="button"
														class="btn btn-default col"
														:class="{ active: isShippingFree }"
														@click="changeShippingType('free')"
													>
														Free
													</button> -->
												</div>
											</div>

											<!-- Automated -->
											<template v-if="isShippingAutomated">
												<!-- Couriers -->
												<div class="form-group">
													<div class="shipping-couriers">
														<label class="mb-3">
															<b>{{ $t('Shipping Couriers') }}:</b>
														</label>
														<div class="row">
															<div
																v-for="(courier, index) in shippingCouriers"
																:key="index"
																class="col-6 col-md-4"
															>
																<label>
																	<input
																		type="checkbox"
																		class="input-checkbox"
																		:value="courier.key"
																		v-model="shipping.couriers"
																		:disabled="checkCourierDisabled(courier)"
																	/>
																	<span></span>
																	<span
																		class="input-checkbox-text shipping-logo"
																		:style="{
																			backgroundImage: `url('/images/logo-${courier.key}.png')`,
																		}"
																		v-tooltip="courier.label"
																	>
																	</span>
																</label>
															</div>
														</div>
													</div>
												</div>

												<!-- Shipping Services -->
												<div class="shipping-services form-group hidden">
													<label><b>Shipping Services:</b></label>
													<div class="container-fluid">
														<div class="row">
															<div
																class="col-lg-4 p-0"
																v-for="(service, index) in shippingServices"
																:key="index"
															>
																<div class="form-group mb-1">
																	<label>
																		<input
																			type="checkbox"
																			class="input-checkbox input-checkbox-large"
																			:value="service.value"
																			v-model="shipping.services"
																			:disabled="
																				shipping.services.length === 1 &&
																				shipping.services.indexOf(
																					service.value,
																				) !== -1
																			"
																		/>
																		<span></span>
																		<span class="input-checkbox-text">
																			<span></span>{{ service.label }}
																			<i
																				class="material-icons info"
																				v-tooltip="service.info"
																				v-if="service.info"
																			>
																				info
																			</i>
																		</span>
																	</label>
																</div>
															</div>
														</div>
													</div>
												</div>

												<!-- Shipping Origin -->
												<div class="shipping-origin mb-3">
													<p><b>Ship From:</b></p>
													<div class="row">
														<div class="col-md-6">
															<!-- Province -->
															<div class="form-group ship-from-field">
																<label>Province</label>
																<multiselect
																	placeholder="Select Province"
																	:class="{error: isFieldError('product', 'shipping_province')}"
																	label="province_name"
																	track-by="province_id"
																	v-model="shipping.province"
																	:options="provinces"
																	:show-labels="false"
																	:allow-empty="false"
																	:loading="isFetchingProvince"
																	:disabled="provinces.length === 0 || isWarehouseSelected"
																	@select="onProvinceChange"
																>
																</multiselect>
															</div>
														</div>
														<div class="col-md-6">
															<!-- City -->
															<div class="form-group ship-from-field">
																<label>City</label>
																<multiselect
																	placeholder="Select City"
																	label="city_name_with_type"
																	track-by="city_id"
																	v-model="shipping.city"
																	:class="{error: isFieldError('product', 'shipping_city')}"
																	:options="cities"
																	:show-labels="false"
																	:allow-empty="false"
																	:loading="isFetchingCity"
																	:disabled="cities.length === 0 || isWarehouseSelected"
																	@select="onCityChange"
																>
																</multiselect>
															</div>
														</div>
														<div class="col-md-6">
															<!-- Subdistrict -->
															<div class="form-group ship-from-field">
																<label>Subdistrict</label>
																<multiselect
																	placeholder="Select Subdistrict"
																	label="subdistrict_name"
																	track-by="_id"
																	v-model="shipping.subdistrict"
																	@select="onSubdistrictChange"
																	:options="subdistricts"
																	:class="{error: isFieldError('product', 'shipping_subdistrict')}"
																	:show-labels="false"
																	:allow-empty="false"
																	:loading="isFetchingSubdistrict"
																	:disabled="subdistricts.length === 0 || isWarehouseSelected"
																>
																</multiselect>
															</div>
														</div>
														<div class="col-md-6">
															<!-- Subdistrict -->
															<div class="form-group ship-from-field">
																<label>ZIP Code</label>
																<input
																	type="text"
																	class="form-control"
																	v-model="shipping.zip"
																	:disabled="isWarehouseSelected"
																/>
															</div>
														</div>
														<div class="col-md-6">
															<!-- Phone -->
															<div class="form-group ship-from-field">
																<label>Phone PIC Pickup</label>
																<input
																	type="text"
																	class="form-control input"
																	:class="{ error: isFieldError('product', 'phone_number_pickup') || isFieldError('product', 'phone_number_pickup_required') }"
																	v-model="shipping.phone_1"
																	:disabled="isWarehouseSelected"
																/>
																<p class="error-messages" v-if="isFieldError('product','phone_number_pickup_required')">{{ getErrorMessage('product', 'phone_number_pickup_required') }}</p>
																<p class="error-messages" v-else-if="isFieldError('product','phone_number_pickup')">{{ getErrorMessage('product', 'phone_number_pickup') }}</p>
															</div>
														</div>
														<div class="col-md-6">
															<!-- Phone -->
															<div class="form-group ship-from-field">
																<label>Phone PIC Support</label>
																<input
																	type="text"
																	class="form-control input"
																	:class="{ error: isFieldError('product', 'phone_number_support') }"
																	v-model="shipping.phone_2"
																	:disabled="isWarehouseSelected"
																/>
																<p class="error-messages" v-if="isFieldError('product','phone_number_support')">{{ getErrorMessage('product', 'phone_number_support') }}</p>
															</div>
														</div>
														<div class="col-md-12">
															<!-- Address -->
															<div class="form-group ship-from-field">
																<label>Address</label>
																<textarea
																	class="form-control"
																	rows="5"
																	v-model="shipping.address"
																	:disabled="isWarehouseSelected"
																></textarea>
															</div>
														</div>
													</div>
												</div>

												<!-- Additional Cost -->
												<div class="form-group m-0 hidden">
													<label><b>Additional Shipping Cost</b></label>
													<!-- <input type="number" class="input form-control" v-model.trim="shipping.markup" @change="onShippingMarkupChange"> -->
													<price-input
														class="input form-control"
														:max="1000000"
														v-model="shipping.markup"
													>
													</price-input>
													<div class="pc-input-desc">
														Add or reduce shipping cost here. (insert negative
														value to reduce shipping cost)
													</div>
												</div>
											</template>

											<!-- Flat -->
											<!-- <template v-if="isShippingFlat">
												<div class="form-group">
													<label>Flat Shipping Price</label>
													<input
														type="text"
														class="input form-control"
														v-model.trim="shipping.flatPrice"
														@change="onShippingFlatChange"
													/>
												</div>
											</template> -->
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Payments | Hidden by request -->
						<div class="pc-payments pc-box box hidden" id="payments">
							<div class="box__title">
								<!-- <span class="box__icon icon icon-payment-orange"></span> -->
								<i class="fi fi-rr-credit-card box__icon"></i>Payment
							</div>
							<!-- <div class="box__subtitle">Choose your payment method</div> -->
							<div class="box__content">
								<!-- Payment Methods -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading">Pilih metode pembayaran</h5>
										<p class="pc-p">
											Metode pembayaran yang dipilih akan ditampilkan pada
											pembeli / dropshiper
										</p>
									</div>
									<div class="col-sm-8">
										<div class="btn-group-vertical w-100" role="group">
											<draggable
												class="w-100 d-block"
												group="payments"
												handle=".group-item"
												v-model="availablePaymentOptions"
												v-bind="dragOptions"
												@start="drag = true"
												@end="drag = false"
												@change="onPaymentSorted"
											>
												<transition-group
													class="d-block w-100"
													type="transition"
													:name="!drag ? 'flip-list' : null"
												>
													<div
														class="w-100"
														v-for="payment in availablePaymentOptions"
														:key="payment.key"
													>
														<div
															class="flex-center btn btn-default btn-default-light btn-block group-item br-0"
														>
															<label
																class="d-flex align-items-center mb-0 w-100 cur-p"
															>
																<i
																	class="material-icons"
																	v-tooltip="'Drag to reorder'"
																	>drag_indicator</i
																>
																<div
																	class="custom-control custom-checkbox flex-center justify-content-between w-100"
																>
																	<input
																		type="checkbox"
																		class="custom-control-input"
																		:value="payment"
																		v-model="selectedPayments"
																	/>
																	<span class="custom-control-label">{{
																		payment.label
																	}}</span>
																</div>
															</label>
															<div class="flex-center">
																<i
																	class="material-icons info"
																	v-tooltip="payment.info"
																	v-if="payment.info"
																	>info</i
																>
																<i
																	class="material-icons text-secondary ml-2"
																	v-tooltip="'Config'"
																	@click.stop="editPaymentDescription(payment)"
																	v-if="payment.key !== 'instant'"
																	>settings</i
																>
															</div>
														</div>
														<template v-if="isPaymentSelected(payment)">
															<!-- COD Couriers -->
															<div
																class="well br-0 mb-minus"
																v-if="payment.key === 'cod'"
															>
																<cod-settings
																	:couriers.sync="codShippingCouriers"
																	:is-smart.sync="shippingSmartMode"
																	v-model="codCourier"
																>
																</cod-settings>
																<!-- <div class="container-fluid">
														<div
															class="form-group"
															v-if="isAdmin || isHasFeature('smart_shipping')">
															<checkbox-toggle
																class="d-inline-block mt-2 mb-4"
																label="Activate Smart Mode"
																info="Sistem Ostock akan memilihkan kurir COD dengan performa terbaik sesuai kecamatan yang dipilih oleh pembeli"
																v-model="shippingSmartMode"
															/>
														</div>
													</div> -->
															</div>

															<!-- Instant Payments Channels -->
															<div
																class="well br-0 mb-minus"
																v-if="payment.key === 'instant'"
															>
																<div class="cod-settings container-fluid">
																	<div class="mt-2 mb-3">
																		<b>E-Payment Channels</b>
																	</div>
																	<payment-channels
																		:has-config="true"
																		v-bind:descriptions.sync="
																			channelsDescriptions
																		"
																		v-model="selectedPaymentChannels"
																	/>
																	<p class="mt-2">
																		Biaya per transaksi dapat di-check di sini:
																		<a
																			href="https://ostock.id/epayment/#pricing"
																			target="_blank"
																			>Biaya Transaksi</a
																		>
																	</p>
																</div>
															</div>
														</template>
													</div>
												</transition-group>
											</draggable>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Landing Page -->
						<div class="pc-options pc-box box" :class="{ 'hidden' : isSupplier }" id="general">
							<div class="box__title">
								<i class="box__icon fi fi-rr-settings-sliders"></i>Landing Page
							</div>
							<div class="box__content">
								<!-- Landing Page -->
								<div class="row mb-2">
									<div class="col-sm-4">
										<h5 class="pc-heading"><b>URL Landing Pages</b></h5>
										<p class="pc-p">
											Cantumkan maksimal 5 url landing page untuk digunakan
											dropshipper menyalin landing page yang disediakan ..
										</p>
									</div>
									<div class="col-sm-8">
										<button
											v-if="
												openPage === false &&
												(landingPage.length === 0 || product.pages.length === 0)
											"
											class="btn btn-default"
											@click="openPage = true"
										>
											+ Tambah URL Landing Page
										</button>
										<div
											class="row mb-4"
											v-if="product.pages.length > 0 || openPage"
										>
											<div class="col-sm-4">
												<!-- URL -->
												<div class="form-group mb-1">
													<select
														class="input form-control"
														v-model="landingPage.type"
													>
														<option
															v-for="(pageType, index) in pageTypes"
															:key="index"
															:value="pageType"
															:disabled="pageType.disabled"
														>
															{{ pageType.label }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-sm-5">
												<!-- URL -->
												<div
													class="form-group mb-1"
													v-if="landingPage.type.value === 'orderonline'"
												>
													<input
														ref="inputLP"
														v-focus
														@keyup.enter="addLandingPage"
														placeholder="Masukan Link Share Page Anda"
														type="text"
														class="input form-control"
														v-model.trim="landingPage.url"
													/>
												</div>
												<!-- Upload -->
												<div
													class="form-group mb-1"
													v-else-if="landingPage.type.value === 'berdu' || landingPage.type.value === 'wordpress'"
												>
													<button class="btn btn-primary" :class="{ 'is-loading': isFileUploading }" @click="uploadFile">
														Upload File JSON/TXT
													</button>
												</div>
											</div>
											<div
												class="col-sm-3"
												v-if="landingPage.type.value === 'orderonline'"
											>
												<div class="form-group mb-1">
													<button
														class="btn btn-primary btn-block"
														:disabled="product.pages.length >= 5"
														v-tooltip="
															product.pages.length >= 5
																? 'Sudah mencapai maksimal penambahan url'
																: 'Masukan hingga 5 url landing page'
														"
														@click="addLandingPage"
													>
														+ Tambah
													</button>
												</div>
											</div>
										</div>
										<div
											v-for="(page, index) in product.pages"
											:key="index"
											class="form-group"
										>
											<div class="well">
												<label
													><b>{{ page.type.label }}</b></label
												>
												<div class="row">
													<div class="col-md-5">
														<div class="form-group mb-1">
															<select
																class="input form-control"
																v-model="page.type"
															>
																<option
																	v-for="(pageType, index) in pageTypes"
																	:key="index"
																	:value="pageType"
																	:disabled="pageType.disabled"
																>
																	{{ pageType.label }}
																</option>
															</select>
														</div>
													</div>
													<div class="col-md-7">
														<div class="input-page-group">
															<input
																class="input form-control input-page"
																v-model="page.url"
															/>
															<i
																class="material-icons form-control-page text-danger mt-1"
																v-tooltip="'Hapus Halaman ini'"
																@click="removeLandingPage(index)"
															>
																close
															</i>
														</div>
													</div>
												</div>
												<div
													v-if="
														openLinkPreview ||
														(page.previews && page.previews.length > 0)
													"
													class="row mt-2"
												>
													<div class="col-md-12 mt-1 mb-2">
														<ol style="padding-inline-start: 20px">
															<li
																v-for="(preview, i) in page.previews"
																:key="i"
															>
																<a :href="preview.url" target="_blank">{{
																	preview.title
																}}</a>
																<i
																	class="material-icons text-danger cursor-pointer"
																	style="font-size: 18px"
																	v-tooltip="'Hapus preview'"
																	@click="removePreview(index, i)"
																>
																	close
																</i>
															</li>
														</ol>
														<label> Judul Preview </label>
														<div class="input-page-group">
															<input
																ref="linkPreview"
																class="input form-control input-page mb-2"
																v-model="input_preview_title[index]"
																@keyup.enter="addPreview(index)"
															/>
														</div>
														<label> Masukan URL Preview </label>
														<div class="input-page-group">
															<input
																class="input form-control input-page mb-3"
																v-model="input_preview_url[index]"
																@keyup.enter="addPreview(index)"
															/>
															<!-- <i
																class="material-icons form-control-page text-success mt-1"
																v-tooltip="'Tambahkan'"
																@click="addPreview(index)"
															>
																done
															</i> -->
														</div>
														<div class="input-page-group justify-content-end">
															<button
																class="btn btn-primary align-items-end"
																@click="addPreview(index)"
															>
																Tambahkan Preview
															</button>
														</div>
													</div>
												</div>
												<div v-else class="row">
													<div class="col-md-12">
														<span class="link" @click="openPreview(index)"
															>+ Tambahkan link preview</span
														>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Belongs To -->
						<div class="pc-belongs-to pc-box box" id="assignation" v-if="!isAdmin">
							<div class="box__title">
								<span class="box__icon"
									><i class="material-icons">people</i></span
								>Assign Product to
							</div>
							<!-- <div class="box__subtitle"></div> -->
							<div class="box__content">
								<!-- Belongs To -->
								<div class="row">
									<div class="col-sm-4">
										<h5 class="pc-heading">Member</h5>
										<p class="pc-p">
											Tambahkan member untuk mengelola produk ini
										</p>
									</div>
									<div class="col-sm-8">
										<product-belongs-to
											:product-id="productId"
											:request-data="false"
											v-bind:members.sync="members"
											v-bind:belongs-to.sync="belongsToMembers"
											v-bind:distribution.sync="orderDistribution"
											ref="belongsTo"
										>
										</product-belongs-to>

										<div class="form-group hidden">
											<label>Members</label>
											<div class="form-group mb-3">
												<multiselect
													class="form-control"
													label="name"
													track-by="_id"
													placeholder="Select Customer Service"
													:reset-after="true"
													:options="membersCS"
													:show-labels="false"
													:loading="isFetchingMembers"
													@select="addBelongsTo"
												>
												</multiselect>
											</div>

											<!-- Selected -->
											<p class="mb-2">Customer Services:</p>
											<div
												class="selected-options"
												v-if="belongsToMembersCS.length > 0"
											>
												<div
													class="selected-option product-belongs-to-member"
													v-for="(member, index) in belongsToMembersCS"
													:key="index"
												>
													<span>{{ member.name }}</span>
													<i
														class="material-icons selected-option-remove"
														v-tooltip="'Remove'"
														@click="removeBelongsTo(member._id)"
														>close</i
													>
												</div>
											</div>

											<multiselect
												class="hidden"
												placeholder="Select Members"
												label="name"
												track-by="_id"
												v-model="belongsToMembers"
												:options="members"
												:show-labels="false"
												:multiple="true"
												:custom-label="belongsToLabel"
												:loading="isFetchingMembers"
											>
											</multiselect>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Actions -->
						<div class="step-actions text-right">
							<button
								type="button"
								class="btn-create-product btn btn-info btn-lg mr-2"
								:class="{ 'is-loading': isCreatingProduct, 'hidden': isAdmin }"
								v-if="!isEditProduct"
								@click="saveAsDraft"
							>
								<i class="material-icons">save_as</i
								><span>Save as Draft</span>
							</button>
							<button
								type="button"
								class="btn-create-product btn btn-primary btn-lg mr-4"
								:class="{ 'is-loading': isCreatingProduct }"
								v-if="!isEditProduct"
								@click="finish"
							>
								<i class="material-icons">check</i
								><span>Save</span>
							</button>
							<button
								type="button"
								class="btn-update-product btn btn-primary btn-lg"
								:class="{ 'is-loading': isUpdatingProduct }"
								v-if="isEditProduct"
								@click="editProduct"
							>
								<i class="material-icons">save</i><span>Update Product</span>
							</button>
						</div>
					</div>
				</div>

				<!-- Done -->
				<div class="col-12" v-if="isStepActive('done')">
					<div class="text-center" v-if="!productData">
						<button
							class="btn btn-primary btn-lg button-done-save"
							:class="{ 'is-loading': isCreatingProduct }"
							@click="finish"
						>
							<i class="material-icons">check</i>Save & get URL
						</button>
					</div>
					<div class="pc-done-box box box--lg text-center" v-if="productData">
						<div class="pc-done-icon"></div>
						<h3 class="pc-done-title">
							{{ product.name }} is Under Verification
						</h3>
						<div class="pc-done-text">
							<p>Your product is under verification, please wait patiently</p>
						</div>
						<div class="pc-done-footer d-flex justify-content-end">
							<button
								@click="back"
								class="btn btn-primary"
							>
								Finish
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Page Loader -->
		<div class="page-content container" v-if="!isProductReady">
			<div class="pc-loader is-loading dark large"></div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Field Settings -->
			<modal
				class="field-settings-modal"
				size="small-medium"
				v-if="isShowFieldSettings && selectedField"
				@close="isShowFieldSettings = false"
			>
				<div slot="body">
					<div class="form-group" v-if="selectedField.name === 'address'">
						<label><b>Field</b></label>
						<select class="form-control" v-model="selectedField.field">
							<option value="input">Input</option>
							<option value="textarea">Textarea</option>
						</select>
					</div>
					<div class="form-group" v-if="!selectedField.mandatory">
						<label><b>Required</b></label>
						<select class="form-control" v-model="selectedField.required">
							<option :value="true">Yes (Required)</option>
							<option :value="false">No</option>
						</select>
					</div>
					<div class="form-group">
						<label><b>Label</b></label>
						<input
							type="text"
							class="form-control"
							v-model="selectedField.label"
						/>
					</div>
					<div class="form-group">
						<label><b>Placeholder</b></label>
						<input
							type="text"
							class="form-control"
							v-model="selectedField.placeholder"
						/>
					</div>
					<!-- Quantity Settings -->
					<template v-if="selectedField.name === 'quantity'">
						<label class="mb-2"><b>Quantity</b></label>
						<div class="row">
							<div class="col-6">
								<div class="form-group">
									<label>Min</label>
									<input
										type="number"
										class="form-control"
										:min="1"
										v-model="selectedField.value.min"
										@change="onQuantityMinChange"
										@input="onQuantityMinInput"
									/>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label>Max</label>
									<input
										type="number"
										class="form-control"
										:min="1"
										v-model="selectedField.value.max"
										@change="onQuantityMaxChange"
										@input="onQuantityMaxInput"
									/>
								</div>
							</div>
							<div class="col">
								<div class="form-group">
									<label>Default</label>
									<input
										type="number"
										class="form-control"
										:min="selectedField.value.min"
										:max="selectedField.value.max"
										v-model="selectedField.value.default"
										@change="onQuantityDefaultChange"
									/>
								</div>
							</div>
						</div>
					</template>
				</div>
				<div slot="footer">
					<button class="btn btn-default" @click="hideFieldSettings">
						{{ $t('Close') }}
					</button>
					<button
						class="btn btn-primary"
						@click="saveFieldSettings(selectedField)"
					>
						{{ $t('Save') }}
					</button>
				</div>
			</modal>

			<!-- Custom Field Settings -->
			<modal
				class="field-settings-modal"
				size="medium"
				v-if="isShowCustomField"
				@close="isShowCustomField = false"
			>
				<div slot="header"><h3>Custom Field</h3></div>
				<div slot="body">
					<div class="row">
						<!-- Field -->
						<div class="col-lg-6">
							<div class="form-group">
								<label><b>Field</b></label>
								<select class="form-control" v-model="customField.field">
									<option value="input">Input</option>
									<option value="textarea">Textarea</option>
									<option value="select">Select</option>
								</select>
							</div>
						</div>
						<!-- Type -->
						<div
							class="col-lg-6"
							:class="{ hidden: customField.field !== 'input' }"
						>
							<div class="form-group">
								<label><b>Input Type</b></label>
								<select class="form-control" v-model="customField.type">
									<option value="text">Text</option>
									<option value="date">Date</option>
									<option value="number">Number</option>
									<option value="email">Email</option>
									<option value="url">URL</option>
									<option value="file">File</option>
								</select>
							</div>
						</div>
						<!-- Required -->
						<div class="col-lg-6">
							<div class="form-group" v-if="!customField.mandatory">
								<label><b>Required</b></label>
								<select class="form-control" v-model="customField.required">
									<option :value="true">Yes (Required)</option>
									<option :value="false">No</option>
								</select>
							</div>
						</div>
						<!-- Label -->
						<div class="col-lg-6">
							<div class="form-group">
								<label><b>Label</b></label>
								<input
									type="text"
									class="form-control"
									v-model.trim="customField.label"
									required
								/>
							</div>
						</div>
						<!-- Placeholder -->
						<div class="col-lg-6">
							<div class="form-group">
								<label><b>Placeholder</b></label>
								<input
									type="text"
									class="form-control"
									v-model.trim="customField.placeholder"
								/>
							</div>
						</div>
						<!-- Options -->
						<div class="col-lg-12" v-if="customField.field === 'select'">
							<hr />
							<label><b>Options</b></label>
							<div class="pc-custom-field-option-list form-group">
								<div
									class="pc-custom-field-option mb-2"
									v-for="(option, index) in customField.options"
									:key="index"
								>
									<div class="input-group">
										<input
											type="text"
											class="input form-control"
											v-model.trim="customField.options[index]"
										/>
										<div
											class="input-group-append"
											v-if="customField.options.length > 1"
										>
											<button
												type="button"
												class="input-group-text btn btn-icon-danger btn-default"
												v-tooltip="'Remove'"
												@click="customField.options.splice(index, 1)"
											>
												<i class="material-icons m-0">delete</i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div class="text-right">
								<button
									type="button"
									class="btn btn-sm btn-primary"
									@click="
										customField.options.push(
											`Option ${customField.options.length + 1}`,
										)
									"
								>
									Add Option
								</button>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button class="btn btn-default" @click="isShowCustomField = false">
						Cancel
					</button>
					<button
						class="btn btn-primary"
						@click="saveFieldSettings(customField)"
					>
						{{ $t('Save') }}
					</button>
				</div>
			</modal>

			<!-- Finish Popup -->
			<modal
				class="finish-publish-modal"
				v-if="isShowFinishPopup"
				@close="isShowFinishPopup = false"
			>
				<div slot="body">
					<div class="form-group text-center">
						<p class="modal-title">
							Do you want to save & publish this product?
						</p>
					</div>
					<div class="text-center">
						<button
							type="button"
							class="btn btn-primary"
							:class="{ 'is-loading': isCreatingProduct }"
							@click="finish"
						>
							<i class="material-icons">check</i>Save & get URL
						</button>
					</div>
				</div>
				<div slot="footer">
					<button class="btn btn-default" @click="isShowFinishPopup = false">
						{{ $t('Close') }}
					</button>
				</div>
			</modal>

			<!-- Section Titles -->
			<modal
				class="section-titles-modal"
				size="medium"
				@close="isShowSectionTitles = false"
				v-if="isShowSectionTitles"
			>
				<div slot="header">
					<h3>Section Titles</h3>
				</div>
				<div slot="body">
					<div class="row">
						<div class="col-sm-6">
							<div class="form-group">
								<label>Form:</label>
								<input
									type="text"
									class="form-control"
									placeholder="Contact"
									v-model="sectionTitles.contact"
								/>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="form-group">
								<label>Variations:</label>
								<input
									type="text"
									class="form-control"
									placeholder="Product Variations"
									v-model="sectionTitles.variations"
								/>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="form-group">
								<label>Payment Methods:</label>
								<input
									type="text"
									class="form-control"
									placeholder="Payment Methods"
									v-model="sectionTitles.payment"
								/>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="form-group">
								<label>Bullet Points:</label>
								<input
									type="text"
									class="form-control"
									placeholder="Bullet Points"
									v-model="sectionTitles.features"
								/>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="form-group">
								<label>Shipping:</label>
								<input
									type="text"
									class="form-control"
									placeholder="Shipping"
									v-model="sectionTitles.shipping"
								/>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- Stock Adjust -->
			<modal
				class="section-titles-modal"
				size="medium"
				v-if="isShowUpdateStock"
				@close="isShowUpdateStock = false"
			>
				<div slot="header">
					<h3>
						<span v-if="stockUpdateType === 'sync'">Adjust</span>
						<span v-if="stockUpdateType === 'increase'">Add</span>
						<span v-if="stockUpdateType === 'decrease'">Reduce</span>
						<span> Stock</span>
						<span> - {{ stockTypeLabel }}</span>
					</h3>
				</div>
				<div slot="body">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label class="font-weight-bold">
									<span>Stock </span>
									<span v-if="stockUpdateType === 'sync'">Quantity</span>
									<span
										class="text-success"
										v-if="stockUpdateType === 'increase'"
										>Increment</span
									>
									<span
										class="text-danger"
										v-if="stockUpdateType === 'decrease'"
										>Decrement</span
									>
								</label>
								<input
									type="text"
									class="form-control"
									placeholder="0"
									min="0"
									@change="stockInputValidation"
									@input = stockInputValidation
									v-model="stockQty"
								/>
								<div class="pc-input-desc" v-if="stockUpdateType === 'sync'">
									<p>Input your real product stock here</p>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label><b>Description</b></label>
								<textarea
									class="form-control"
									placeholder="Stock alteration description"
									v-model="stockDescription"
								></textarea>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowUpdateStock = false"
					>
						Cancel
					</button>
					<button
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingStock }"
						@click="
							updateStock(
								productId,
								stockUpdateType,
								stockQty,
								stockDescription,
								stockVariation,
							)
						"
					>
						<i class="material-icons">save</i>
						<span>{{ $t('Save') }}</span>
					</button>
				</div>
			</modal>

			<!-- Form Settings -->
			<modal
				class="form-settings-modal"
				size="medium"
				@close="isSettingsVisible = false"
				v-if="isSettingsVisible"
			>
				<div slot="header">
					<h3>Form Display Settings</h3>
				</div>
				<div slot="body">
					<form-settings
						:mode.sync="form.settings.mode"
						:initialFields.sync="form.settings.initial_fields"
						:label.sync="form.settings.label"
						:fields="fields"
					>
					</form-settings>
				</div>
				<div slot="footer">
					<!-- <button class="btn btn-default" @click="hideFieldSettings">{{ $t('Close') }}</button> -->
					<button class="btn btn-primary" @click="isSettingsVisible = false">
						OK
					</button>
				</div>
			</modal>

			<!-- Confirm Change Type -->
			<modal
				size="medium"
				@close="isShowConfirmChangeTypeModal = false"
				v-if="isShowConfirmChangeTypeModal"
			>
				<div slot="header">
					<h3>Konfirmasi Perubahan Tipe</h3>
				</div>
				<div slot="body">
					Produk Anda mengaktifkan fitur Harga Wholesale.
					Fitur ini hanya berlaku untuk produk bertipe simple.
					Jika mengubah ke tipe variable, fitur Harga Wholesale akan dimatikan.
					Apakah Anda ingin melanjutkan mengubah tipe produk menjadi variable?
				</div>
				<div slot="footer">
					<button class="btn btn-default" @click="isShowConfirmChangeTypeModal = false">
						{{ $t('Close') }}
					</button>
					<button class="btn btn-primary" @click="continueChangeProductType">
						{{ $t('OK') }}
					</button>
				</div>
			</modal>

			<!-- Payment Method Description -->
			<modal
				class="section-titles-modal"
				size="medium"
				@close="isPaymentMethodDescriptionVisible = false"
				v-if="isPaymentMethodDescriptionVisible && selectedPayment"
			>
				<template slot="header">
					<h3>Method Description - {{ selectedPayment.label }}</h3>
				</template>
				<template slot="body">
					<div class="form-group mb-0">
						<textarea
							class="form-control"
							placeholder="Description"
							:value="methodsDescriptions[selectedPayment.key]"
							@input="onMethodsDescriptionChange"
						>
						</textarea>
					</div>
				</template>
			</modal>
		</div>

		<!-- Selector -->
		<!-- <section-selector v-if="step !== 'done'"></section-selector> -->

		<!-- Etc -->
		<textarea class="clipboard" id="clipboard"></textarea>

		<!-- Notifications -->
		<notifications
			group="productCreator"
			position="bottom right"
		></notifications>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import Errors from '@/components/Errors.vue';
import ProductAttributes from '@/components/ProductAttributes.vue';
import ProductBelongsTo from '@/components/ProductBelongsTo.vue';
import ProductCategory from '@/components/ProductCategory.vue';
import PriceInput from '@/components/PriceInput.vue';
import CodSettings from '@/components/CodSettings.vue';
import FormSettings from '@/components/FormSettings.vue';
import Loader from '@/components/Loader.vue';
import PaymentChannels from '@/components/PaymentChannels.vue';
// import Wholesale from '@/components/Wholesale.vue';
import SmartToggle from '@/components/SmartToggle.vue';
// import SelectSupplier from '@/components/products/SelectSupplier.vue';
import {
	duplicateVar,
	getAxiosErrorMessage,
	scrollTo,
	isVariableChanged,
	isValidDate,
	slugify,
	pixelEventsFormatter,
	isValidYoutubeUrl,
	parseNumber,
	getOstockCommissionValue,
	getOstockVariantCommissionValue,
	getProductBadges,
	toTitleCase,
} from '@/lib/helper';
import {
	reservedSlugs,
	shippingCouriers,
	shippingServices,
	defaultFields,
	defaultProduct,
	defaultFormSettings,
	defaultForm,
	defaultBump,
	defaultOrderDistribution,
	defaultCustomField,
	defaultSectionTitles,
	defaultStock,
	defaultBuyButton,
	defaultSubmitAction,
	defaultBulletPoints,
	defaultMultipleVariations,
	defaultUniqueCodeOstock,
	defaultShipping,
	defaultWholesaleItem,
	StockUpdate,
	multipleVariationsQuantityTypes,
	multipleVariationsSelectTypes,
	multipleVariationsRowTypes,
	guaranteeSeals,
	productHeader,
	paymentOptions,
	codCouriers,
	paymentChannels,
	defaultSuccessInstantText,
	defaultLandingPage,
	defaultPageTypes,
	defaultMargin,
	defaultUom,
	defaultOutsourceCommision,
	defaultDistributorObject,
} from '@/lib/statics';
import userApi from '@/api/user';
import productsApi from '@/api/products';
import formsApi from '@/api/forms';
import mediaApi from '@/api/media';
import teamApi from '@/api/team';
import collectionsApi from '@/api/collections';
import warehouseApi from '@/api/warehouse';

const priceLimit = 10000000000;

const ContentEditor = () => ({
	component: import(
		/* webpackChunkName: "content-editor" */ '@/components/ContentEditor.vue'
	),
	loading: Loader,
});

const NewInventorySection = () => ({
	component: import(/* webpackChunkName: "new-inventory-section" */ '@/components/products/new-inventory/Index.vue'),
	loading: Loader,
});

export default {
	name: 'productCreator',
	props: {
		id: {
			type: String,
		},
		formId: {
			type: String,
		},
		entity: {
			type: String,
			default: 'product',
		},
		action: {
			type: String,
			default: 'create',
		},
	},
	components: {
		Modal,
		// Testimonial,
		Errors,
		// BoxTracking,
		ProductAttributes,
		ProductBelongsTo,
		ProductCategory,
		// Wholesale,
		PriceInput,
		// ProgressBar,
		// SectionSelector,
		CodSettings,
		draggable,
		FormSettings,
		// FormSettingsInfo,
		// CheckboxToggle,
		ContentEditor,
		// ImageUploader,
		PaymentChannels,
		SmartToggle,
		// SelectSupplier,
		NewInventorySection,
	},
	data() {
		return {
			isLoading: [false, false, false, false, false, false, false, false, false, false],
			isLoadingIndex: 0,
			input_preview_title: [],
			input_preview_url: [],
			previews: [],
			openLinkPreview: false,
			openPage: false,
			openCommission: false,
			landingPage: defaultLandingPage,
			dropship: {
				enabled: true,
				type: 'nominal',
				margin: 10000,
				max_dropshipper: 0,
				current_dropshipper: 0,
			},
			isRouteChecked: false,
			pageTitle: 'Create Product',
			backgroundColor: 'grey',
			productImages: [],
			productImagesLimit: 10,
			product: duplicateVar(defaultProduct),
			productDetails: null,
			descriptionTreshold: 200,
			bump: defaultBump,
			header: productHeader,
			previewType: 'desktop',
			fields: defaultFields,
			buyButton: defaultBuyButton,
			bulletPoints: defaultBulletPoints,
			testimonials: [],
			selectedField: null,
			isShowFieldSettings: false,
			paymentOptions: duplicateVar(paymentOptions),
			selectedPayments: duplicateVar(paymentOptions),
			guaranteeSeals,
			guaranteeSeal: {
				enabled: true,
				value: 'satisfaction_id',
			},
			coupon: {
				enabled: true,
			},
			videoUrl: '',
			layout: '1_step_right',
			shippingCouriers: duplicateVar(shippingCouriers),
			shippingServices,
			shipping: duplicateVar(defaultShipping),
			pixel: {
				ids: [],
				events: ['ViewContent'],
			},
			successPixel: {
				ids: [],
				events: ['AddToCart'],
			},
			pixelConfigs: [],
			successPixelConfigs: [],
			gtm: {
				ids: [],
			},
			successGtm: {
				ids: [],
			},
			isShowConfirmChangeTypeModal: false,
			submitAction: duplicateVar(defaultSubmitAction),
			isShowFinishPopup: false,
			textToCopy: '',
			form: defaultForm,
			formDetails: null,
			uniqueCode: defaultUniqueCodeOstock,
			orderonlineLogo: true,
			reservedSlugs,
			isFetchingMembers: false,
			members: [],
			belongsToMembers: [],
			orderDistribution: defaultOrderDistribution,
			oldOrderDistribution: null,
			errorFieldId: '',
			isShowCustomField: false,
			customField: defaultCustomField,
			isEditCustomField: false,
			summary: {
				enabled: true,
			},
			isShowSectionTitles: false,
			sectionTitles: duplicateVar(defaultSectionTitles),
			isSimpleWholesaleError: false,
			multipleVariationsQuantityTypes,
			multipleVariationsSelectTypes,
			multipleVariationsRowTypes,
			multipleVariations: defaultMultipleVariations,
			isUploadingHeaderImage: false,
			headerImageProgress: 0,
			isShowUpdateStock: false,
			isUpdatingStock: false,
			stockUpdateType: 'sync',
			stockQty: 0,
			stockDescription: '',
			stockVariation: null,
			stockType: 'catalog',
			codCourier: duplicateVar(codCouriers[0]),
			activeBodyText: 'bank_transfer',
			drag: false,
			dragOptions: {
				animation: 100,
			},
			isSettingsVisible: false,
			codShippingCouriers: ['sap'],
			formDescription: '',
			maxQuantity: {
				enabled: false,
				value: 1,
			},
			collections: [],
			productCollections: [],
			dropshipEnabled: false,
			tiktokPixelIds: [],
			tiktok: {
				ids: [],
			},
			tiktokSuccess: {
				ids: [],
			},
			paymentChannels: duplicateVar(paymentChannels),
			selectedPaymentChannels: this.defaultSelectedPaymentChannels(duplicateVar(paymentChannels)),
			availablePaymentOptions: [],
			channelsDescriptions: {},
			methodsDescriptions: {},
			selectedPayment: null,
			isPaymentMethodDescriptionVisible: false,
			shippingSmartMode: false,
			selected_reseller_type: 'commission',
			resellerTypes: [
				{
					value: 'commission',
					label: this.$t('resellers.settings.commission'),
				},
				{
					value: 'discount',
					label: this.$t('resellers.settings.discount'),
				},
			],
			reseller: {
				enabled: false,
				commission: {
					value: 'commission',
					label: this.$t('resellers.settings.commission'),
				},
				commission_type: 'commission',
				override_commission_type: false,
				override_reseller_product_tier: false,
				point: 1,
				tiers: [],
			},
			discount_types: ['percentage', 'nominal'],
			discount_value: '',
			discount_type: '',
			selected_tier: '',
			productErrors: {},
			pageTypes: defaultPageTypes,
			separatorToken: '||',
			statusProduct: 'request',
			currentIndexUploadImage: 0,
			allWarehouse: [],
			selectedWarehouse: null,
			prevStatus: null,
			isCODEnabled: true,
			isDistributorPriceEnabled: false,
			distributor: duplicateVar(defaultDistributorObject),
			selectedSupplier: null,
			tempProductId: null,
			variationWeightError: [],
			variationEnabledError: false,
			isFileUploading: false,
			isSearchSupplier: false,
			supplierOptions: [],
		};
	},
	methods: {
		...mapActions({
			setStoreShippingProvince: 'setStoreShippingProvince',
			setStoreShippingCity: 'setStoreShippingCity',
			setStoreShippingSubdistrict: 'setStoreShippingSubdistrict',
			setStorefrontStatus: 'setStorefrontStatus',
			changeStep: 'productCreator/changeStep',
			addStepError: 'productCreator/addStepError',
			removeStepError: 'productCreator/removeStepError',
			setProductData: 'productCreator/setProductData',
			createProduct: 'productCreator/createProduct',
			updateProduct: 'productCreator/updateProduct',
			setFormData: 'productCreator/setFormData',
			createForm: 'productCreator/createForm',
			updateForm: 'productCreator/updateForm',
			fetchCities: 'productCreator/fetchCities',
			setErrorMessage: 'productCreator/setErrorMessage',
			fetchSubdistricts: 'productCreator/fetchSubdistricts',
			clearCities: 'productCreator/clearCities',
			clearSubdistricts: 'productCreator/clearSubdistricts',
			resetStepErrors: 'productCreator/resetStepErrors',
			setProductType: 'productWarehouse/setProductType',
			setProductPrices: 'productWarehouse/setProductPrices',
		}),
		fetchDataSupplier(query) {
			this.ooDelay(() => {
				if (query !== '') {
					this.fetchSuppliers(query);
				}
			}, 1000);
		},
		isLimited(dropship) {
			return dropship.current_dropshipper >= dropship.max_dropshipper;
		},

		checkCourierDisabled(courier) {
			const dangerousGoodsForbiddenCouriers = ['jnt', 'idexpress'];
			const dangerousGoodsBadge = this.checkProductBadge(this.product, 'dangerous_goods');
			const isDisabled = courier.force_enabled
				|| (dangerousGoodsForbiddenCouriers.includes(courier.key) && dangerousGoodsBadge);

			return isDisabled;
		},

		openPreview() {
			this.openLinkPreview = true;
			// const self = this;
			// this.$nextTick(() => {
			// 	self.$refs.linkPreview[index].focus();
			// });
		},

		back() {
			const route = this.backUrl;
			this.goToDetail({ name: route.name });
		},

		goToDetail(to) {
			this.reset();
			this.$router.push(to);
		},

		addPreview(index) {
			const title = this.input_preview_title[index];
			const url = this.input_preview_url[index];
			const option = {
				title,
				url,
			};
			this.product.pages[index].previews.push(option);
			this.input_preview_url[index] = '';
			this.input_preview_title[index] = '';
			// const self = this;
			// this.$nextTick(() => {
			// 	self.$refs.linkPreview[index].focus();
			// });
		},
		removePreview(index, i) {
			const prev = this.product.pages[index].previews.splice(i, 1);
			if (this.product.pages[index].previews.length !== 0) {
				this.$set(
					this.product.pages[index],
					this.product.pages[index].previews,
					prev,
				);
			}
		},

		addLandingPage() {
			if (this.product.pages.length < 5) {
				this.product.pages.unshift(duplicateVar(this.landingPage));
				this.landingPage = {
					type: {
						value: 'orderonline',
						label: 'Order Online',
						disabled: false,
					},
					url: '',
					previews: [],
				};
				if (this.$refs.inputLP) {
					this.$refs.inputLP.focus();
				}
			}
		},

		removeLandingPage(index) {
			if (this.product.pages.length > 0) {
				this.product.pages.splice(index, 1);
			}
		},

		checkCommisionPecentage() {
			if (
				this.product.commission_percentage < 5
				|| this.product.commission_percentage === ''
			) {
				this.product.commission_percentage = 5;
			}
			this.calculateInvPrice();
		},

		calculateInvPrice() {
			// const commission = this.lowestPrice * (this.product.commission_percentage / 100);
			// this.product.cogs = !isNaN(this.lowestPrice) ? this.lowestPrice - commission : 0;
			// eslint-disable-next-line no-restricted-globals
			this.product.cogs = !isNaN(this.lowestPrice) ? this.lowestPrice : 0;
		},

		handleDragOver(event) {
			event.preventDefault();
		},
		handleDragEnter(event) {
			event.preventDefault();
			event.currentTarget.classList.add('drag-over');
		},
		handleDragLeave(event) {
			event.preventDefault();
			event.currentTarget.classList.remove('drag-over');
		},
		handleDrop(event, index) {
			event.preventDefault();
			event.currentTarget.classList.remove('drag-over');
			const files = event.dataTransfer.files;
			if (files.length === 1) {
				this.currentIndexUploadImage = index;
				this.onProductImagesChange({ target: { files } });
			} else if (files.length > 1) {
				let uploadedIndex = 0;

				const handleBulkUpload = (startIndex) => {
					for (let i = startIndex; i < this.product.images.length; i++) {
						const item = this.product.images[i];
						// eslint-disable-next-line no-continue
						if (item !== '') continue;
						this.currentIndexUploadImage = i;

						const uploadResult = this.onProductImagesChange({ target: { files: [files[uploadedIndex]] } });
						uploadedIndex += 1;

						if (!uploadResult) {
							handleBulkUpload(i);
							return;
						}
					}
				};

				handleBulkUpload(0);

				if (uploadedIndex < files.length) {
					const noticeMessage = `Maksimum upload ${this.productImagesLimit} foto produk`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
				}
			}
		},
		uploadImages(index) {
			this.currentIndexUploadImage = index;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		uploadFile() {
			// console.log('upload file');
			const inputFile = this.$refs.fileUploader;
			inputFile.click();
		},
		addProductTier() {
			// console.log(this.selected_tier);
			if (this.selected_tier === '' || !this.selected_tier) {
				this.$notify({
					group: 'productCreator',
					title: 'Add Tier',
					text: 'Tidak boleh kosong',
					type: 'error',
				});
			} else {
				const tier = {
					discount_type: this.selected_tier.discount_type,
					discount_value: this.selected_tier.discount_value,
					level: this.selected_tier.level,
					name: this.selected_tier.name,
					product_id: this.productId,
					tier_id: this.selected_tier._id,
				};
				this.setAppendNewProductTier(tier);
				this.selected_tier = '';
			}
		},
		removeProductTier(index) {
			this.$store.commit('resellerTiers/DELETE_RESELLER_PRODUCT_TIERS', index);
		},
		updateDiscountType(val, index) {
			this.$store.commit('resellerTiers/UPDATE_DISCOUNT_TYPE', {
				val: val.target.value,
				index,
			});
		},
		updateDiscountValue(val, index) {
			const value = val.target.value;
			const parsedValue = value.replace(/[^0-9.-]/g, '').trim();
			this.$store.commit('resellerTiers/UPDATE_DISCOUNT_VALUE', {
				value: parsedValue,
				index,
			});
		},
		isStepActive(step) {
			return this.step === step;
		},
		changeProductStatus(status) {
			this.product.status = status;
			this.statusProduct = status;
		},
		continueChangeProductType() {
			this.isShowConfirmChangeTypeModal = false;
			this.isDistributorPriceEnabled = false;
			this.changeProductType('variable', 'continue');
		},
		changeProductType(type, state = 'confirm') {
			if (state === 'confirm' && type === 'variable' && this.isDistributorPriceEnabled && this.isHasFeaturePrivateOrder) {
				this.isShowConfirmChangeTypeModal = true;
				return;
			}
			this.product.type = type;
			this.autoCheckMultipleVariation();
			this.setProductType(type);
		},
		autoCheckMultipleVariation() {
			if (this.product.type === 'variable') {
				this.product.variations.multiple_variations.enabled = true;
			} else {
				this.product.variations.multiple_variations.enabled = false;
			}
		},
		onProductNameChange() {
			if (this.product.slug === '') {
				this.product.slug = this.slugify(this.product.name);
			}
		},
		onProductImagesChange(event) {
			this.isLoading[this.currentIndexUploadImage] = true;
			let isSuccess = true;
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				let fileType = image.type.split('/');
				fileType = fileType[fileType.length - 1];

				const validFileTypes = ['jpeg', 'jpg', 'png'];
				if (!validFileTypes.includes(fileType)) {
					const noticeMessage = 'File yang diupload tidak sesuai';
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					this.productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				if (isLimitReached) {
					const noticeMessage = `Maksimum upload ${this.productImagesLimit} foto produk`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading[this.currentIndexUploadImage] = false;
					isSuccess = false;
					break;
				}

				this.productImages.push(image);

				// const previewIndex = this.productImages.length - 1;
				const previewIndex = this.currentIndexUploadImage;

				this.$set(this.product.images, previewIndex, '');

				// Load the image file into a canvas element
				const img = new Image();
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const reader = new FileReader();
				reader.onload = () => {
					img.onload = () => {
						const size = Math.max(img.width, img.height);
						canvas.width = size;
						canvas.height = size;
						const offsetX = (size - img.width) / 2;
						const offsetY = (size - img.height) / 2;
						ctx.fillStyle = '#fff';
						ctx.fillRect(0, 0, size, size); // fill the canvas with white
						ctx.drawImage(img, offsetX, offsetY);

						// Convert the canvas to a blob and upload it to the server
						canvas.toBlob((blob) => {
							// Start Upload
							const uploadParams = new FormData();
							uploadParams.append('image', blob);

							const callback = (response) => {
								this.isLoading[this.currentIndexUploadImage] = false;
								const path = response.data;
								const url = `${this.mediaUrlPrefix}/${path}`;
								this.$set(this.product.images, previewIndex, url);
							};

							const errorCallback = () => {
								this.isLoading[this.currentIndexUploadImage] = false;
								// eslint-disable-next-line
								this.productImages.splice(previewIndex, 1);
								this.product.images.splice(previewIndex, 1);
							};

							// Upload Image
							mediaApi.uploadImage(uploadParams, callback, errorCallback);
						}, image.type, 0.9);
					};
					img.src = reader.result;
				};
				reader.readAsDataURL(image);
			}
			event.target.files = null;
			event.target.value = '';
			return isSuccess;
		},
		onFileChange(event) {
			// console.log('on file change');
			const maxUploadSize = 2; // MB
			const input = event.target;
			this.isFileUploading = true;

			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				let fileType = image.type.split('/');
				fileType = fileType[fileType.length - 1];

				const validFileTypes = ['json', 'txt', 'plain'];
				if (!validFileTypes.includes(fileType)) {
					const noticeMessage = 'File yang diupload tidak sesuai';
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					this.isFileUploading = false;
					break;
				}

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'productCreator',
						text: noticeMessage,
						type: 'warn',
					});
					this.isFileUploading = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('file', image);
				uploadParams.append('resize', false);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					// this.$set(this.product.images, previewIndex, url);
					this.landingPage.url = url;
					this.addLandingPage();
					this.isFileUploading = false;
				};

				const errorCallback = (e) => {
					// eslint-disable-next-line
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadFile(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		removeProductImages(index) {
			// const imageUrl = this.product.images[index];
			// const imagePath = imageUrl.replace('https://cdn.ostock.id/uploads/', '');
			// mediaApi.remove(imagePath);
			this.productImages.splice(index, 1);
			// this.product.images.splice(index, 1);
			this.product.images.splice(index, 1, '');
			// this.$set(this.product.images, index, '');
			this.isLoading[index] = false;
		},
		showFieldSettings(field) {
			const clonedField = duplicateVar(field);
			if (!field.name.includes('custom')) {
				this.selectedField = clonedField;
				this.isShowFieldSettings = true;
			} else {
				this.customField = clonedField;
				this.isShowCustomField = true;
			}
		},
		hideFieldSettings() {
			this.selectedField = null;
			this.customField = null;
			this.isShowFieldSettings = false;
			this.isShowCustomField = false;
		},
		saveFieldSettings(fieldData) {
			const field = duplicateVar(fieldData);
			const index = this.fields.findIndex(
				currField => currField.name === field.name,
			);
			if (index !== -1) {
				this.fields.splice(index, 1, field);
			} else {
				this.fields.push(field);
			}
			this.hideFieldSettings();
		},
		onWarehouseChange(warehouse) {
			this.shipping.province = {
				province_id: warehouse.province.id,
				province_name: warehouse.province.name,
			};
			this.clearCities();
			this.clearSubdistricts();
			this.shipping.city = {
				city_id: warehouse.city.id,
				city_name_with_type: warehouse.city.name,
			};
			this.clearSubdistricts();
			this.shipping.subdistrict = {
				subdistrict_id: warehouse.subdistrict.id,
				subdistrict_name: warehouse.subdistrict.name,
			};
			this.shipping.zip = warehouse.zip;
			this.shipping.phone_1 = warehouse.phone_primary;
			this.shipping.phone_2 = warehouse.phone_secondary;
			this.shipping.address = warehouse.address;

			const isWarehouseOfficial = warehouse?.is_official ?? false;
			if (isWarehouseOfficial) {
				this.shipping.warehouse_id = warehouse._id;
				this.shipping.is_warehouse_official = true;
			}
		},
		onProvinceChange(province) {
			this.shipping.province = province;
			this.shipping.city = null;
			this.shipping.subdistrict = null;
			this.clearCities();
			this.clearSubdistricts();
			const provinceId = province.province_id;
			this.fetchCities(provinceId);
		},
		onCityChange(city) {
			this.shipping.city = city;
			this.shipping.subdistrict = null;
			this.clearSubdistricts();
			const cityId = city.city_id;
			this.fetchSubdistricts(cityId);
		},
		onSubdistrictChange(subdistrict) {
			this.shipping.zip = subdistrict.zip;
		},
		changeShippingType(type = 'automated') {
			if (type === 'automated') {
				this.shipping.flat = false;
				this.shipping.free = false;
			} else if (type === 'flat') {
				this.shipping.flat = true;
				this.shipping.free = false;
			} else if (type === 'free') {
				this.shipping.flat = false;
				this.shipping.free = true;
			}
		},
		generateShippingParams() {
			const flatPrice = parseInt(this.shipping.flatPrice);
			const markup = parseInt(this.shipping.markup);
			const couriers = this.shipping.couriers.slice();
			const services = this.shipping.services.slice();
			const provinceId = this.shipping.province
				? this.shipping.province.province_id
				: 0;
			const provinceName = this.shipping.province
				? this.shipping.province.province_name
				: '';
			const cityId = this.shipping.city ? this.shipping.city.city_id : 0;
			const subdistrictId = this.shipping.subdistrict
				? this.shipping.subdistrict.subdistrict_id
				: 0;
			// const type = this.shipping.city ? 'city' : '';
			// const name = this.shipping.city ? this.shipping.city.city_name_with_type : '';
			const type = this.shipping.subdistrict ? 'subdistrict' : '';
			const cityName = this.shipping.city
				? this.shipping.city.city_name_with_type
				: '';
			const subdistrictName = this.shipping.subdistrict
				? this.shipping.subdistrict.subdistrict_name
				: '';
			const isSmart = this.shippingSmartMode;
			let mode = 'normal';
			if (isSmart) {
				mode = 'smart';
			}
			const shipping = {
				enabled: this.shipping.enabled,
				free_shipping: this.shipping.free,
				flat_shipping: this.shipping.flat,
				flat_price: flatPrice,
				origin: {
					// id: cityId,
					id: subdistrictId,
					type,
					name: subdistrictName,
					province_id: provinceId,
					province_name: provinceName,
					city_id: cityId,
					city_name: cityName,
					subdistrict_id: subdistrictId,
					subdistrict_name: subdistrictName,
					address: this.shipping.address,
					phone_1: this.shipping.phone_1,
					phone_2: this.shipping.phone_2,
					zip: this.shipping.zip,
				},
				couriers,
				services,
				markup,
				cod: this.codCourier,
				cod_couriers: this.codShippingCouriers,
				mode,
			};

			if (this.isWarehouseSelected) {
				const warehouseId = this.selectedWarehouse?._id ?? null;
				if (warehouseId !== null) {
					shipping.origin.warehouse_id = warehouseId;
				}

				const isWarehouseOfficial = this.selectedWarehouse?.is_official ?? false;
				if (isWarehouseOfficial) {
					shipping.origin.is_warehouse_official = true;
				}
			}

			return shipping;
		},
		checkProductBadge(product, key = 'cod') {
			const badges = getProductBadges(product);
			return badges[key] ?? false;
		},
		generateProductParams() {
			const type = this.product.type;
			if (
				this.product.dropship
				&& this.product.dropship.max_dropshipper
				&& this.dropship.max_dropshipper >= this.product.dropship.max_dropshipper
			) {
				this.product.dropship.enabled = true;
			}

			const isSimple = type === 'simple';
			const simplePrice = this.product.price;
			let price = isSimple
				? simplePrice
				: this.product.variations.prices[0].price;
			price = parseInt(price);

			this.product.dropship.original_price = price;

			const salePrice = this.salePrice;
			const salePriceJSON = JSON.stringify(salePrice);

			const productWeight = this.product.weight
				? parseInt(this.product.weight)
				: 1;
			const cogs = this.product.cogs;
			const landingPages = this.product.pages;

			// if (this.isInactiveVariationExists) {
			// 	this.autoCheckMultipleVariation();
			// }

			const variations = this.product?.variations ?? {};

			// hotfix parse int quantity because in production read as a string
			if (variations?.prices) {
				variations.prices = (variations.prices || []).map((variation) => {
					if (variation.stock?.quantity) {
						variation.stock.quantity = parseInt(variation.stock.quantity) || 0;
					}
					return variation;
				});
			}

			// validate warehouse selected, uncheck if warehouse not selected
			this.product.stock.warehouse_enabled = !!this.isWarehouseSelected;

			const pictures = this.product.images
				.filter(image => image !== '')
				.slice();
			const payments = this.payments;
			const shipping = this.generateShippingParams();
			const bumpWeight = this.bump.weight ? parseInt(this.bump.weight) : 1;
			const bump = {
				status: this.bump.enabled,
				name: this.bump.name,
				price: this.bump.price,
				weight: bumpWeight,
				url: '',
				data: {
					checkbox_label: this.bump.checkbox,
					title: this.bump.title,
					description: this.bump.content,
					image: this.bump.image,
				},
			};

			const uniqueCode = this.uniqueCode;
			const reseller = this.reseller;
			const dropship = this.product.dropship;
			// set productTier to reseller
			const productTiers = this.productTiers;
			const description = this.product.description.trim();
			const maxQuantity = this.maxQuantity;

			const belongsTo = this.belongsToMembers.map(member => member._id);
			const orderDistribution = this.orderDistribution;
			const category = this.product.category;
			const categoryKeys = Object.keys(category);
			for (let index = 0; index < categoryKeys.length; index++) {
				const categoryKey = categoryKeys[index];
				const categoryValue = category[categoryKey];
				if (!categoryValue || categoryValue === '') {
					delete category[categoryKey];
				}
			}

			const collections = this.productCollections.map(({ slug }) => slug);

			this.product.stock.quantity = parseInt(this.product.stock.quantity);
			let productStock = this.product.stock;

			if (this.isNewInventoryVisible && (this.stock?.enabled || this.stock?.multi_warehouse)) {
				productStock = {
					...this.product.stock,
					enabled: this.stock.enabled,
					backorder: this?.stock?.backorder ?? 1,
					// eslint-disable-next-line camelcase
					multi_warehouse: this?.stock?.multi_warehouse ?? false,
					// eslint-disable-next-line camelcase
					multi_warehouse_type: this?.stock?.multi_warehouse_type ?? 'nearest',
					status: this?.stock?.status ?? 1,
				};
			}

			const picturesJSON = JSON.stringify(pictures);
			const videosJSON = JSON.stringify(this.product.videos);
			const paymentsJSON = JSON.stringify(payments);
			const shippingJSON = JSON.stringify(shipping);
			const bumpJSON = JSON.stringify(bump);
			const pagesJSON = JSON.stringify(landingPages);
			const uniqueCodeJSON = JSON.stringify(uniqueCode);
			const resellerJSON = JSON.stringify(reseller);
			const dropshipJSON = JSON.stringify(dropship);
			const productTiersJSON = JSON.stringify(productTiers);
			const belongsToJSON = JSON.stringify(belongsTo);
			const orderDistributionJSON = JSON.stringify(orderDistribution);
			const wholesaleJSON = JSON.stringify(this.product.wholesale);
			const categoryJSON = JSON.stringify(category);
			const stockJSON = JSON.stringify(productStock);
			const maxQuantityJSON = JSON.stringify(maxQuantity);
			const collectionsJson = JSON.stringify(collections);
			const paymentChannelsJSON = JSON.stringify(this.selectedPaymentChannels);
			const paymentChannelsDescriptionsJSON = JSON.stringify(
				this.channelsDescriptions,
			);
			const paymentMethodsDescriptionsJSON = JSON.stringify(
				this.methodsDescriptions,
			);
			const distributorJSON = JSON.stringify(this.distributor);

			const uomJSON = isSimple ? JSON.stringify(this.product.uom) : JSON.stringify(this.product.variations.prices[0].uom);

			const changeLogs = JSON.stringify(this.product.change_logs);

			if ((this.productId && this.product.status !== 'live' && this.product.status !== 'reject') || this.isAdmin) {
				this.statusProduct = this.product.status;
			}

			// Check Commission, if less than 2350 then replace to type nominal with value 2350
			// this function will return true if less than 2350

			if (!this.isEditProduct) {
				if (this.product.type === 'simple') {
					// this.product.outsource_commission.type = 'nominal';
					// this.product.outsource_commission.value = 0;
					// const isCommissionNeedReplace = this.checkCommission(this.product);
					// if (isCommissionNeedReplace) {
					// 	this.product.outsource_commission.type = 'nominal';
					// 	this.product.outsource_commission.value = 2350;
					// }
					this.product.outsource_commission.type = 'percentage';
					this.product.outsource_commission.value = 5;
				} else if (this.product.type === 'variable' && variations?.prices) {
					this.product.outsource_commission.type = 'nominal';
					this.product.outsource_commission.value = 0;
					variations.prices = (variations.prices || []).map((variation) => {
						variation.outsource_commission = variation?.outsource_commission || duplicateVar(defaultOutsourceCommision);
						// variation.outsource_commission.type = 'nominal';
						// variation.outsource_commission.value = 0;
						// const isCommissionNeedReplace = this.checkCommission(variation);
						// if (isCommissionNeedReplace) {
						// 	variation.outsource_commission.type = 'nominal';
						// 	variation.outsource_commission.value = 2350;
						// } else {
						// 	variation.outsource_commission.type = 'percentage';
						// 	variation.outsource_commission.value = 5;
						// }
						variation.outsource_commission.type = 'percentage';
						variation.outsource_commission.value = 5;

						return variation;
					});
				}
			}

			const outsourceCommissionJSON = JSON.stringify(this.product.outsource_commission);
			const variationsJSON = JSON.stringify(variations);

			this.product.slug = this.slugify(this.product.name);

			const productParams = {
				name: this.product.name,
				slug: this.product.slug,
				code: this.product.code,
				type,
				price,
				uom: uomJSON,
				sale_price: salePriceJSON,
				unique_code_price: uniqueCodeJSON,
				variations: variationsJSON,
				weight: productWeight,
				status: this.statusProduct,
				pictures: picturesJSON,
				videos: videosJSON,
				payments: paymentsJSON,
				payment_channels: paymentChannelsJSON,
				payment_channels_descriptions: paymentChannelsDescriptionsJSON,
				payment_methods_descriptions: paymentMethodsDescriptionsJSON,
				shipping: shippingJSON,
				bump: bumpJSON,
				belongs_to: belongsToJSON,
				wholesale: wholesaleJSON,
				category: categoryJSON,
				cogs,
				stock: stockJSON,
				is_public: this.product.isPublic,
				description,
				max_quantity: maxQuantityJSON,
				collections: collectionsJson,
				reseller: resellerJSON,
				dropship: dropshipJSON,
				product_tiers: productTiersJSON,
				pages: pagesJSON,
				outsource_commission: outsourceCommissionJSON,
				commission_percentage: this.product.commission_percentage,
				// commission_percentage: 0,
				change_logs: changeLogs,
			};

			if (this.isHasFeaturePrivateOrder) {
				productParams.distributor = distributorJSON;
			}

			const isOrderDistributionChanged = isVariableChanged(
				duplicateVar(this.oldOrderDistribution),
				duplicateVar(orderDistribution),
			);
			if (isOrderDistributionChanged) {
				productParams.order_distribution = orderDistributionJSON;
			}

			if (this.isAdmin) {
				productParams.supplier_user_id = this.selectedSupplier._id;
			}

			if (this.tempProductId) {
				productParams.temp_product_id = this.tempProductId;
			}

			return productParams;
		},
		generateOtherParams() {
			const autoresponders = [];
			const form = this.formParams;
			const notifications = [
				{
					name: 'email',
					data: this.selectedSupplier ? this.selectedSupplier.email : this.user.email,
				},
			];
			const fbCustomAudiences = [];

			const autorespondersJSON = JSON.stringify(autoresponders);
			const formJSON = JSON.stringify(form);
			const notificationsJSON = JSON.stringify(notifications);
			const fbCustomAudiencesJSON = JSON.stringify(fbCustomAudiences);

			const otherParams = {
				is_deleted: false,
				autoresponders: autorespondersJSON,
				form: formJSON,
				notifications: notificationsJSON,
				facebook_custom_audiences: fbCustomAudiencesJSON,
			};

			return otherParams;
		},
		generateParams() {
			const productParams = this.generateProductParams();
			const otherParams = this.generateOtherParams();
			const params = Object.assign({}, productParams, otherParams);
			return params;
		},
		generateFormParams() {
			const form = this.formParams;
			const formJSON = JSON.stringify(form);
			const params = {
				product_id: this.productId,
				form: formJSON,
			};
			return params;
		},
		createNewProduct() {
			const params = this.generateParams();
			const cb = (response) => {
				const data = response.data;

				if (data.status === 'draft' || this.isAdmin) { // redirect back if is admin
					this.back();
				}
			};
			const errorCb = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'productCreator',
					title: 'Create Product',
					text: message,
					type: 'error',
				});
			};
			this.createProduct({ params, cb, errorCb });
		},
		finish() {
			// new validation
			this.validateAllForm();

			const currentStepErrors = this.stepErrors('product');
			console.log('🚀 ~ finish ~ currentStepErrors:', currentStepErrors);
			const isHasErrors = Object.keys(currentStepErrors).length > 0;

			if (!isHasErrors) {
				// If no product id then create product
				if (!this.productId) {
					if (this.isUpdateDefaultShipping) {
						if (!this.isHasStoreAddress) {
							this.updateDefaultShipping();
						}
						this.createNewProduct();
					} else {
						this.createNewProduct();
					}
				} else if (!this.formId) {
					// Create Form
					const params = this.generateFormParams();
					this.createForm(params);
				} else {
					// Update Form
					const params = this.generateFormParams();
					this.updateForm({ id: this.formId, params });
				}
			} else {
				window.scrollTo(0, 0);
			}
		},
		editProduct() {
			// this.validateStepProduct();

			// new validation
			this.validateAllForm();

			const currentStepErrors = this.stepErrors('product');
			const isHasErrors = Object.keys(currentStepErrors).length > 0;

			if (!isHasErrors) {
				if (!this.isHasStoreAddress) {
					this.updateDefaultShipping();
				}
				// set status to request if product suspended
				if (this.product.status === 'suspended') {
					this.changeProductStatus('request');
				}
				// Update Product
				const params = this.generateProductParams();
				const cb = () => {
					this.$notify({
						group: 'productCreator',
						text: 'Product updated successfully',
						type: 'success',
					});
					// Redirect to product details
					this.back();
				};
				const errorCb = (e) => {
					// eslint-disable-next-line
					console.log(e);
					this.$notify({
						group: 'productCreator',
						text: 'Update product failed, please try again.',
						type: 'error',
					});
				};
				this.updateProduct({ id: this.productId, params, cb, errorCb });
			} else {
				window.scrollTo(0, 0);
			}
		},
		saveAsDraft() {
			this.changeProductStatus('draft');

			// new validation
			this.validateAllForm();

			// auto check multiple variations if product type is variant (variable)
			this.autoCheckMultipleVariation();

			const currentStepErrors = this.stepErrors('product');

			const step = 'product';
			if (this.isFieldError(step, 'name')) {
				this.product.name = `product-draft-${this.moment().format('DD-MM-YYYY_hh-mm-ss')}`;
				this.onProductNameChange();
			}
			if (this.isFieldError(step, 'code')) {
				this.product.code = `c-draft-${this.moment().format('DD-MM-YYYY_hh-mm-ss')}`;
			}
			if (this.isFieldError(step, 'category')) {
				this.product.category.category = 'Uncategorized';
				this.product.category.category_slug = 'uncategorized';
			}

			this.validateAllForm();

			const isHasErrors = Object.keys(currentStepErrors).length > 0;

			if (!isHasErrors) {
				// If no product id then create product
				if (!this.productId) {
					if (this.isUpdateDefaultShipping) {
						if (!this.isHasStoreAddress) {
							this.updateDefaultShipping();
						}
						this.createNewProduct();
					} else {
						this.createNewProduct();
					}
				}
			} else {
				window.scrollTo(0, 0);
			}
		},
		showFinishPopup() {
			this.isShowFinishPopup = true;
		},
		nextStep(nextStep) {
			if (this.step === 'product') {
				this.validateStepProduct();
			}

			const currentStepErrors = this.stepErrors(this.step);

			if (Object.keys(currentStepErrors).length > 0) {
				window.scrollTo(0, 0);
			} else {
				this.changeStep(nextStep);
			}
		},
		validateProductName(name) {
			const step = 'product';
			const key = 'name';
			const maxName = 100;
			if (name === '' || name.length > maxName) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				console.log(stepError);
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateVideoURL(url) {
			const step = 'product';
			const key = 'videos';
			// eslint-disable-next-line
			if (url != '' && isValidYoutubeUrl(url) === false) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				console.log(stepError);
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateProductCategory(category) {
			const step = 'product';
			const key = 'category';
			if (category === '' || category === null || category === undefined
				|| category === 'Produk Lainnya' || category === 'Uncategorized') {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				console.log(stepError);
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateSlug(slug) {
			if (slug !== '' && this.reservedSlugs.indexOf(slug) === -1) {
				const callback = () => {
					const stepError = { step: 'product', key: 'slug' };
					this.removeStepError(stepError);
				};
				const errorCallback = (e) => {
					// eslint-disable-next-line
					console.log(e);
					const error = this.getErrorMessage('product', 'slug');
					const stepError = { step: 'product', key: 'slug', error };
					this.addStepError(stepError);
				};
				const productId = this.productId ? this.productId : 0;
				productsApi.validateSlug(productId, slug, callback, errorCallback);
			} else {
				const error = this.getErrorMessage('product', 'slug');
				const stepError = { step: 'product', key: 'slug', error };
				this.addStepError(stepError);
			}
		},
		validateProductCode() {
			const step = 'product';
			const key = 'code';
			if (this.product.code === '') {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateProductWeight() {
			const step = 'product';
			const key = 'weight';
			if (this.product.type === 'simple') {
				if ((this.shipping.enabled && this.product.weight === '') || this.product.weight < 1) {
					const error = this.getErrorMessage(step, key);
					const stepError = { step, key, error };
					this.addStepError(stepError);
					console.log(stepError);
				} else if (this.isFieldError(step, key)) {
					this.removeStepError({ step, key });
				}
			}
		},
		showAlert(title, text, type = 'warn') {
			this.$notify({
				group: 'productCreator',
				title,
				text,
				type,
			});
		},
		transformKey(key) {
			// replace underscore to space, capitalize first letter of each words
			return key.replace('_', ' ').replace(/\b[a-z](?=[a-z]{2})/g, letter => letter.toUpperCase());
		},
		validateProductStock() {
			const step = 'product';
			const keySimple = 'stock_simple';
			const keyVariable = 'stock_variable';
			let key = keySimple;

			// reset step error
			this.removeStepError({ step, key: keySimple });
			this.removeStepError({ step, key: keyVariable });

			// validate stock non multiwarehouse
			if (!this.isMultiWarehouse) {
				if (this.product.type === 'simple' && this.product.stock.quantity < 0) {
					key = keySimple;

					const error = this.getErrorMessage(step, key);
					const stepError = { step, key, error };
					this.addStepError(stepError);

					const title = this.transformKey(key);
					this.showAlert(title, error);
				}

				if (this.product.type === 'variable') {
					const variations = this.product.variations.prices;
					let hasZeroStock = false;

					variations.forEach((item) => {
						if (item.stock.quantity < 0) {
							hasZeroStock = true;
						}
					});

					if (hasZeroStock) {
						key = keyVariable;

						const error = this.getErrorMessage(step, key);
						const stepError = { step, key, error };
						this.addStepError(stepError);

						const title = this.transformKey(key);
						this.showAlert(title, error);
					}
				}
			}
		},
		validateProductPrice(price) {
			const step = 'product';
			const key = 'price';
			const minPrice = 1000;
			if ((price === '' || price < 0 || price > priceLimit || price < minPrice) && this.product.type !== 'variable') {
				let error = this.getErrorMessage(step, key);
				if (price > priceLimit) {
					error = 'Price cannot be greater than 10 Billion Rupiah';
				}

				if (price < minPrice) {
					const keyMessage = 'price';
					error = 'Price cannot be lower than 1000';
					const payload = { step, keyMessage, message: error };
					this.setErrorMessage(payload);
				}
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateProductVariations() {
			const step = 'product';
			const key = 'variations';
			const isVariable = this.product.type === 'variable';
			const isNoPrices = this.product.variations.prices.length === 0;
			const isError = isVariable && isNoPrices;
			if (isError) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateShippingCouriers() {
			const step = 'product';
			const key = 'shipping_couriers';
			const couriers = this.shipping.couriers;
			if (this.shipping.enabled && couriers.length < 1) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateShippingprovince() {
			const step = 'product';
			const key = 'shipping_province';
			if (
				this.shipping.enabled
				&& this.isShippingAutomated
				&& this.shipping.province === null
			) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateShippingCity() {
			const step = 'product';
			const key = 'shipping_city';
			if (
				this.shipping.enabled
				&& this.isShippingAutomated
				&& this.shipping.city === null
			) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateShippingSubdistrict() {
			const step = 'product';
			const key = 'shipping_subdistrict';
			if (
				this.shipping.enabled
				&& this.isShippingAutomated
				&& this.shipping.subdistrict === null
			) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validatePayment() {
			const step = 'product';
			const key = 'payment';
			if (this.selectedPayments.length === 0) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateSuccessCS() {
			const step = 'product';
			const key = 'cs_wa';
			const isTypeWa = this.submitAction.type.key === 'cs_wa';
			if (isTypeWa && this.belongsToMembersCS.length === 0) {
				if (!this.isFieldError(step, key)) {
					let error = this.getErrorMessage(step, key);
					if (this.isCreateProduct) {
						const fixLink =
							'<a href="#assignation" class="error-fix-link" data-step="product" data-id="assignation">Fix Error</a>';
						error += ` ${fixLink}`;
					}
					const stepError = { step, key, error };
					this.addStepError(stepError);
				}
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validateProductStatus() {
			if (this.isAdmin && this.isEditProduct) { // bypass if admin edit product
				return;
			}

			if (!this.isEditProduct && this.product.status === 'draft') {
				this.changeProductStatus('draft'); // create product with draft status
			} else if (!this.isEditProduct && this.product.status !== 'disabled') {
				this.changeProductStatus('pricing'); // create product with verification status
			} else if (this.isEditProduct && this.product.status !== 'disabled' && (this.prevStatus === 'disabled' || this.prevStatus === 'draft')) {
				if (this.product.is_verified) {
					this.changeProductStatus('request'); // edit product from disabled or draft status and is_verified is true
				} else {
					this.changeProductStatus('pricing'); // edit product from disabled or draft status and is_verified is false or null
				}
			} else if (this.isEditProduct && this.product.status !== 'disabled' && (this.prevStatus === 'reject' || this.prevStatus === 'suspended' || this.prevStatus === 'live')) {
				this.changeProductStatus('request'); // edit product from reject, suspended or live status
			} else if (this.isEditProduct && this.product.status !== 'disabled' && this.prevStatus !== 'disabled') {
				this.changeProductStatus(this.prevStatus); // edit product from pricing, recontent, landing_page or verification status
			}
		},
		validateSupplier() {
			if (!this.isAdmin) { // bypass if is supplier
				return;
			}
			const step = 'product';
			const key = 'supplier';
			if (!this.selectedSupplier) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		validatePhonePic() {
			const step = 'product';
			const keys = {
				pickup: 'phone_number_pickup',
				pickupRequired: 'phone_number_pickup_required',
				support: 'phone_number_support',
			};
			const phoneRegex = /^(?:\+62|0)[1-9][0-9]{7,14}$/;

			const removeErrors = (keys) => {
				Object.values(keys).forEach(key => this.removeStepError({ step, key }));
			};

			const addError = (key) => {
				const error = this.getErrorMessage(step, key);
				this.addStepError({ step, key, error });
			};

			removeErrors(keys);

			// Validate pickup PIC phone
			if (!this.shipping.phone_1 || !this.shipping.phone_1.length) {
				addError(keys.pickupRequired);
			} else if (!phoneRegex.test(this.shipping.phone_1)) {
				addError(keys.pickup);
			}

			// Validate support PIC phone
			if (this.shipping.phone_2 && this.shipping.phone_2.length && !phoneRegex.test(this.shipping.phone_2)) {
				addError(keys.support);
			}
		},
		validateAllForm() {
			// Product Name
			this.validateProductName(this.product.name);
			// Product Code
			this.validateProductCode();
			// Product Category
			this.validateProductCategory(this.product.category.category);
			if (this.product.type === 'simple') {
				// Product Weight
				this.validateProductWeight();
			}

			if (this.product.type === 'variable') {
				// Weight Varian
				if (this.product?.variations?.prices) {
					this.validateVariableWeight(this.product.variations.prices);
				}
			}
			// Product Price
			this.validateProductPrice(this.product.price);
			// Product Variations
			this.validateProductVariations();
			// Shipping Couriers
			this.validateShippingCouriers();
			// Shipping province
			this.validateShippingprovince();
			// Shipping City
			this.validateShippingCity();
			// Shipping Subdistrict
			this.validateShippingSubdistrict();
			// Youtube Video URL
			this.validateVideoURL(this.product.videos[0] || '');
			// disabled by request
			// Stock
			this.validateProductStock();
			// Status
			this.validateProductStatus();
			// Supplier
			this.validateSupplier();
			// Warehouse
			this.validateWarehouse();
			// Phone PIC Pickup
			this.validatePhonePic();
		},
		focusErrorField() {
			const fields = document.getElementsByClassName('input error');
			if (fields.length > 0) {
				const field = fields[0];
				field.focus();
			}
		},
		copyToClipBoard(text) {
			const clipboard = document.getElementById('clipboard');
			clipboard.value = text;
			clipboard.select();
			document.execCommand('copy');

			this.$notify({
				group: 'productCreator',
				text: 'Product URL has been copied',
				type: 'success',
			});
		},
		setDefaultShipping() {
			if (this.defaultShipping) {
				this.shipping.couriers = this.defaultShipping.couriers.slice();

				// set force enabled couriers to store settings
				const forcedCouriers = shippingCouriers.filter(
					({ force_enabled }) => !!force_enabled, // eslint-disable-line camelcase
				);

				forcedCouriers.forEach((courier) => {
					const courierKey = courier.key;
					if (this.shipping.couriers.indexOf(courierKey) === -1) {
						this.shipping.couriers.push(courierKey);
					}
				});

				// Set Province
				if (this.provinces.length > 0) {
					const provinceId = this.defaultShipping.origin.province.id;
					this.shipping.province = this.provinces.find(
						province => province.province_id === provinceId,
					);
					this.fetchCities(provinceId);
				}

				this.shipping.phone_1 = this.defaultShipping.origin.phone_1;
				this.shipping.phone_2 = this.defaultShipping.origin.phone_2;
				this.shipping.address = this.defaultShipping.origin.address;
				this.shipping.zip = this.defaultShipping.origin.zip;
			}
		},
		customFormatter(date) {
			// return this.moment(date).format('DD-MM-YYYY hh:mm:ss');
			return this.moment(date).format('DD-MM-YYYY');
		},
		fetchProductDetails(productId) {
			const callback = (response) => {
				this.productDetails = response.data;
				if (this.isAdmin) {
					this.fetchSuppliers(this.productDetails.user_id);
				}
				this.setProductPrices(response.data?.variations?.prices);
			};

			const errorCallback = (e) => {
				const status = e?.response?.status;
				if (status === 404) {
					this.back();
				}
			};

			// Fetch Product Details
			productsApi.getProductDetails(productId, callback, errorCallback);
		},
		setProduct(details) {
			const product = duplicateVar(details);

			const dateFormatFull = 'DD-MM-YYYY hh:mm:ss';
			const salePrice = product.sale_price;
			let saleScheduleSinceDate = this.moment(
				salePrice.schedule.since,
				dateFormatFull,
			).toDate();
			let saleScheduleUntilDate = this.moment(
				salePrice.schedule.until,
				dateFormatFull,
			).toDate();
			if (!isValidDate(saleScheduleSinceDate)) {
				saleScheduleSinceDate = this.moment().toDate();
			}
			if (!isValidDate(saleScheduleUntilDate)) {
				saleScheduleUntilDate = this.moment().toDate();
			}
			salePrice.schedule.since = saleScheduleSinceDate;
			salePrice.schedule.until = saleScheduleUntilDate;

			// original array of pictures
			const images = product.pictures;

			// Pictures
			const pictures = product.pictures.filter(picture => picture !== '');
			const limit = this.productImagesLimit - pictures.length;
			if (pictures.length < this.productImagesLimit) {
				for (let i = 0; i < limit; i++) {
					pictures.push('');
				}
			}

			// handle variations old data
			const isOldData = this.isVariationOldData(product.variations);
			if (isOldData) {
				product.variations.attributes = this.fixProductVariationAttributes(
					product.variations,
				);
			}

			if (!product.uom) {
				this.product.uom = duplicateVar(defaultUom);
			}

			// Set Weight, COGS, Stock for Variations
			const fixVariationPriceProperties = (currPrice, i) => {
				const hasWeightProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'weight',
				);
				const hasCogsProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'cogs',
				);
				const hasStockProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'stock',
				);

				const hasVariantCodeProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'variant_code',
				);

				const hasEnabledProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'enabled',
				);

				const hasMarginProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'margin',
				);

				const hasIdProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'id',
				);

				const hasUomProperty = Object.prototype.hasOwnProperty.call(
					currPrice,
					'uom',
				);

				if (!hasWeightProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.weight = duplicateVar(product.weight);
				}
				if (!hasCogsProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.cogs = 0;
				}
				if (!hasStockProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.stock = duplicateVar(defaultStock);
				}
				if (!hasUomProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.uom = duplicateVar(defaultUom);
				}
				if (!hasIdProperty) {
					// eslint-disable-next-line no-param-reassign
					let id = this.$uuid.v4();
					if (isOldData) {
						id = this.generatePriceIdFromVariation(product.variations, i);
					}
					currPrice.id = id;
				}
				if (!hasVariantCodeProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.variant_code = '';
				}
				if (!hasEnabledProperty) {
					// eslint-disable-next-line no-param-reassign
					currPrice.enabled = true;
				}
				if (!hasMarginProperty) {
					currPrice.margin = defaultMargin;
				}
			};
			product.variations.prices.forEach(fixVariationPriceProperties);

			// Fixing Variations Data Model
			const productVariations = Object.assign(
				{},
				this.product.variations,
				product.variations,
			);

			if (product.pages && product.pages === '') {
				this.product.pages = [];
			} else {
				this.product.pages = duplicateVar(product.pages);
			}

			this.product.user_id = product?.user_id || null;
			this.product.name = product.name;
			this.product.slug = product.slug;
			this.product.code = product.code;
			this.product.status = product.status;
			this.product.is_verified = product?.is_verified || null;
			this.prevStatus = product.status;
			this.product.images = duplicateVar(pictures);
			this.product.videos = duplicateVar(product.videos);
			this.product.commission_percentage = product.commission_percentage || 5;
			this.product.type = product.type;
			this.product.price = product.price;
			this.product.sale_price = salePrice;
			this.product.variations = productVariations;
			this.product.weight = product.weight;
			this.product.cogs = product.cogs || 0;
			this.product.tags = product.tags ?? [];
			if (this.product.pages.length > 0) {
				this.product.pages.forEach((page, index) => {
					if (!page.previews) {
						this.product.pages[index].previews = [];
					}
				});
			}
			if (this.product.pages === '' || this.product.pages === null) {
				this.product.pages = [];
			}

			if (product.description) {
				this.product.description = product.description;
			}

			if (product.category) {
				this.product.category = product.category;
			}

			if (product.wholesale) {
				this.product.wholesale = product.wholesale;
			}

			// Stock
			if (product.stock) {
				this.product.stock = product.stock;
				this.selectedWarehouseId = product.shipping.origin.warehouse_id;
				this.assignSelectedWarehouse(this.selectedWarehouseId);
			}

			this.productImages = duplicateVar(images);

			if (typeof product.distributor !== 'undefined') {
				this.distributor = product.distributor;
				this.isDistributorPriceEnabled = this.distributor?.enabled ?? false;
			}

			// Bump
			this.bump.enabled = product.bump.status;
			this.bump.name = product.bump.name;
			this.bump.price = product.bump.price;
			this.bump.checkbox = product.bump.data.checkbox_label;
			this.bump.title = product.bump.data.title;
			this.bump.content = product.bump.data.description;

			if (product.bump.weight) {
				this.bump.weight = product.bump.weight;
			}

			if (product.bump.data.image) {
				this.bump.image = product.bump.data.image;
			}

			// Shipping
			const services = product.shipping.services
				? product.shipping.services
				: ['regular'];
			const shippingMode = product?.shipping?.mode ?? 'normal';

			this.shipping.enabled = product.shipping.enabled;
			this.shipping.couriers = product.shipping.couriers;
			this.shipping.services = services;
			this.shipping.free = product.shipping.free_shipping;
			this.shipping.phone_1 = product.shipping.origin.phone_1;
			this.shipping.phone_2 = product.shipping.origin.phone_2;
			this.shipping.address = product.shipping.origin.address;
			this.shipping.zip = product.shipping.origin.zip;
			this.shipping.flat = product.shipping.flat_shipping
				? product.shipping.flat_shipping
				: false;
			this.shipping.flatPrice = product.shipping.flat_price
				? product.shipping.flat_price
				: 0;
			this.shipping.markup = product.shipping.markup
				? product.shipping.markup
				: 0;
			this.shipping.mode = shippingMode;

			// set force enabled couriers to store settings
			const forcedCouriers = shippingCouriers.filter(
				({ force_enabled }) => !!force_enabled, // eslint-disable-line camelcase
			);

			forcedCouriers.forEach((courier) => {
				const courierKey = courier.key;
				if (this.shipping.couriers.indexOf(courierKey) === -1) {
					this.shipping.couriers.push(courierKey);
				}
			});

			if (this.provinces.length !== 0) {
				const provinceId = product.shipping.origin.province_id;
				// eslint-disable-next-line
				const province = this.provinces.find(
					province => province.province_id === provinceId,
				);
				if (province) {
					this.shipping.province = province;
					this.fetchCities(provinceId);
				}
			}

			// Add City ID
			if (
				!product.shipping.origin.city_id
				&& product.shipping.origin.type === 'city'
			) {
				product.shipping.origin.city_id = product.shipping.origin.id;
				product.shipping.origin.city_name = product.shipping.origin.name;
			}

			if (this.cities.length !== 0) {
				const cityId = product.shipping.origin.city_id;
				// eslint-disable-next-line
				const city = this.cities.find(city => city.city_id == cityId);
				if (city) {
					this.shipping.city = city;
					this.fetchSubdistricts(cityId);
				}
			}

			if (shippingMode === 'smart') {
				this.shippingSmartMode = true;
			}

			const payments = product.payments.map((key) => {
				const lowerCasedKey = key.toLowerCase();
				const paymentOption = this.paymentOptions.find(
					option => option.key === lowerCasedKey,
				);
				return paymentOption;
			});
			const validPayments = payments.filter(payment => !!payment);
			this.selectedPayments = validPayments;
			this.isCODEnabled = this.isCODSelected;
			this.setPayments();

			// Unique Code
			this.uniqueCode = product.unique_code_price;
			// Reseller
			if (product.reseller) {
				this.reseller = product.reseller;
			}
			// DropShip Commission
			if (product.dropship) {
				this.product.dropship = product.dropship;
				this.dropship = product.dropship;
			}

			// COD Settings
			const codCourier = product.shipping.cod || codCouriers[0];
			if (!codCourier.feeType) {
				codCourier.feeType = 'product';
			}
			this.codCourier = codCourier;

			// COD Couriers
			const codShippingCouriers = product.shipping.cod_couriers || [];
			this.codShippingCouriers = codShippingCouriers;

			// Is Public
			if (product.is_public !== undefined) {
				this.product.isPublic = product.is_public;
			}

			// Max Quantity
			if (product.max_quantity) {
				this.maxQuantity = product.max_quantity;
			}

			// Product Collections
			this.productCollections = [];
			if (product.collections && this.collections.length > 0) {
				const collections = product.collections;
				const selectedCollections = this.collections.filter(({ slug }) => collections.includes(slug));
				this.productCollections = selectedCollections;
			}

			// Payment Channels
			if (product.payment_channels && product.payment_channels.length > 0) {
				this.selectedPaymentChannels = duplicateVar(product.payment_channels);
			}

			// Payment Channels Descriptions
			if (product.payment_channels_descriptions) {
				this.channelsDescriptions = duplicateVar(
					product.payment_channels_descriptions,
				);
			}

			// Payment Methods Descriptions
			if (product.payment_methods_descriptions) {
				this.methodsDescriptions = duplicateVar(
					product.payment_methods_descriptions,
				);
			}

			// Outsource Commission
			if (product.outsource_commission) {
				this.product.outsource_commission = product.outsource_commission;
			}

			if (product.uom) {
				this.product.uom = product.uom;
			}
		},
		fetchFormDetails(formId) {
			const callback = (response) => {
				this.formDetails = response.data;
			};

			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
			};

			// Fetch Product Details
			formsApi.getDetails(formId, callback, errorCallback);
		},
		mergeFields(savedFields) {
			defaultFields.forEach((field, index) => {
				const theFieldIndex = savedFields.findIndex(
					savedField => savedField.name === field.name,
				);
				if (theFieldIndex === -1) {
					field.enabled = false;
					savedFields.splice(index, 0, field);
				} else if (field.mandatory) {
					savedFields[theFieldIndex].mandatory = true;
				}
			});
			return savedFields;
		},
		setForm(details) {
			const form = duplicateVar(details);
			const isGuaranteeSealEnabled = form.elements.guarantee_seals !== '';
			const guaranteeSeal = {
				enabled: isGuaranteeSealEnabled,
				value: form.elements.guarantee_seals,
			};
			const fields = this.mergeFields(form.elements.fields);
			const productName = this.productDetails ? this.productDetails.name : '';

			this.form.name = form.name;
			this.layout = form.style.template;
			this.backgroundColor = form.style.background;
			this.header = form.elements.header;
			this.guaranteeSeal = guaranteeSeal;
			this.fields = fields;
			this.buyButton.text = form.elements.buy_button.text;
			this.buyButton.color = form.elements.buy_button.background;
			this.videoUrl = form.elements.video.url;
			this.videoUrl = form.elements.video.url;
			this.product.imageEnabled = form.elements.image.enabled;
			// this.product.description = form.elements.description;
			this.formDescription = form.elements.description;
			this.coupon = form.elements.coupon;
			this.bulletPoints = form.elements.features;
			this.testimonials = form.elements.testimonials;
			// eslint-disable-next-line
			this.orderonlineLogo = form?.elements?.footer?.orderonline_logo ?? true;

			if (form.elements.order_summary) {
				this.summary = form.elements.order_summary;
			}

			if (!this.header.title || typeof this.header.title === 'string') {
				this.$set(this.header, 'title', { enabled: true, text: productName });
			}

			if (form.elements.section_titles) {
				this.sectionTitles = form.elements.section_titles;
				if (
					!this.sectionTitles.shipping
					&& this.sectionTitles.shipping !== ''
				) {
					this.sectionTitles.shipping = 'Pengiriman:';
				}
			}

			if (form.elements.multiple_variations) {
				if (!form.elements.multiple_variations.row_type) {
					form.elements.multiple_variations.row_type = 'static';
				}
				if (!form.elements.multiple_variations.add_label) {
					form.elements.multiple_variations.add_label = 'Tambah Variasi';
				}
				this.multipleVariations = form.elements.multiple_variations;
			}

			// Tracking - Checkout
			const pixelEvents = form.tracking.form.pixel.events.map(
				pixelEvent => pixelEvent.name,
			);

			this.pixel.ids = form.tracking.form.pixel.ids;
			this.pixel.events = pixelEvents;
			this.pixelConfigs = duplicateVar(form.tracking.form.pixel.events);
			this.gtm.ids = form.tracking.form.gtm.ids;

			this.tiktok.ids =
				form.tracking.form
				&& form.tracking.form.tiktokPixel
				&& form.tracking.form.tiktokPixel.ids
					? duplicateVar(form.tracking.form.tiktokPixel.ids)
					: [];

			// On Submit
			const submitActionType = form.submit_action.type;
			const submitType = this.submitActionTypes.find(
				type => type.key === submitActionType,
			);
			this.submitAction.type = submitType;

			// Success URL
			const url = form.submit_action.data.url;
			this.submitAction.url = url;

			// WhatsApp Numbers
			const waNumbers = form.submit_action.data.wa_numbers;
			this.submitAction.waNumbers = waNumbers;

			// Success Header
			const defaultSuccesHeader = {
				title: { enabled: true, text: productName },
			};
			const successHeader = form.submit_action.data.header
				? form.submit_action.data.header
				: defaultSuccesHeader;
			this.$set(this.submitAction, 'header', successHeader);

			// Success Headline
			const headline = form.submit_action.data.headline;
			this.submitAction.headline = headline;

			// Success Body Text
			const bodyText = form.submit_action.data.body_text;
			this.submitAction.bodyText = bodyText;

			// Success Body Text - COD
			const bodyTextCod = form.submit_action.data.body_text_cod || '';
			this.submitAction.bodyTextCod = bodyTextCod;

			// Success Body Text - Instant
			let bodyTextInstant = form.submit_action.data.body_text_instant || '';
			if (bodyTextInstant === '') {
				bodyTextInstant = defaultSuccessInstantText;
			}
			this.submitAction.bodyTextInstant = bodyTextInstant;

			// Success Video
			const video = form.submit_action.data.video;
			this.submitAction.video = video;

			// Success Tracking
			const successPixelEvents = form.tracking.success.pixel.events.map(
				pixelEvent => pixelEvent.name,
			);
			this.successPixel.ids = form.tracking.success.pixel.ids;
			this.successPixel.events = successPixelEvents;
			this.successPixelConfigs = duplicateVar(
				form.tracking.success.pixel.events,
			);
			this.successGtm.ids = form.tracking.success.gtm.ids;

			this.tiktokSuccess.ids =
				form.tracking.success
				&& form.tracking.success.tiktokPixel
				&& form.tracking.success.tiktokPixel.ids
					? duplicateVar(form.tracking.success.tiktokPixel.ids)
					: [];

			// Form Settings
			const formSettings = Object.assign(
				{},
				defaultFormSettings,
				form.settings,
			);
			this.form.settings = formSettings;

			// Dropship
			this.dropshipEnabled = !!form.elements.dropship_enabled;
		},
		resetProduct() {
			this.product = duplicateVar(defaultProduct);
			this.uniqueCode = duplicateVar(defaultUniqueCodeOstock);
			this.bump = duplicateVar(defaultBump);
			this.stock = duplicateVar(defaultStock);
			this.multipleVariations = duplicateVar(defaultMultipleVariations);
			this.uniqueCode = duplicateVar(defaultUniqueCodeOstock);
			this.productCollections = [];
		},
		resetForm() {
			this.form = duplicateVar(defaultForm);
			this.fields = duplicateVar(defaultFields);
			this.buyButton = duplicateVar(defaultBuyButton);
			this.bulletPoints = duplicateVar(defaultBulletPoints);
			this.submitAction = duplicateVar(defaultSubmitAction);

			this.previewType = 'desktop';
			this.testimonials = [];
			this.selectedField = null;

			this.sectionTitles = duplicateVar(defaultSectionTitles);
		},
		resetShipping() {
			this.shipping = duplicateVar(defaultShipping);
		},
		reset() {
			this.resetProduct();
			this.resetForm();
			// Check product id
			if (!this.productId) {
				// Reset Product
				// this.resetProduct();
				this.changeStep('product');
			} else {
				// Fetch product details
				this.fetchProductDetails(this.productId);
			}
		},
		parsePricing(price) {
			if (typeof price !== 'string') {
				price = price.toString();
			}

			let parsedPrice = price.replace(/[^0-9]/g, '').trim();
			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}

			return parsedPrice;
		},
		onPriceChange() {
			this.product.price = this.parsePricing(this.product.price);
		},
		onPriceChanges() {
			if (this.product.price === '') {
				this.product.price = 0;
			}
		},
		onDistributorPriceChange() {
			this.distributor.price = Number(this.parsePricing(this.distributor.price));
		},
		onDistributorPriceChanges() {
			if (this.distributor.price === '') {
				this.distributor.price = 0;
			}
		},
		onStockChange() {
			this.product.stock.quantity = this.parsePricing(this.product.stock.quantity);
		},
		onDistributorStockChange() {
			this.distributor.stock.quantity = Number(this.parsePricing(this.distributor.stock.quantity));
		},
		onVariableStockChange(value) {
			value.stock.quantity = this.parsePricing(value.stock.quantity);
		},
		onSalePriceChange() {
			this.product.sale_price.price = this.parsePricing(
				this.product.sale_price.price,
			);
		},
		updateDefaultShipping() {
			if (this.isAdmin) {
				return;
			}
			const store = duplicateVar(this.user.store);
			const province = {
				id: this.shipping.province.province_id,
				name: this.shipping.province.province_name,
			};
			const city = {
				id: this.shipping.city.city_id,
				name: this.shipping.city.city_name_with_type,
			};
			const subdistrict = {
				id: this.shipping.subdistrict.subdistrict_id,
				name: this.shipping.subdistrict.subdistrict_name,
			};

			store.shipping.origin.province = province;
			store.shipping.origin.city = city;
			store.shipping.origin.subdistrict = subdistrict;
			store.shipping.origin.phone_1 = this.shipping.phone_1;
			store.shipping.origin.zip = this.shipping.zip;
			store.shipping.origin.phone_2 = this.shipping.phone_2;
			store.shipping.origin.address = this.shipping.address;

			if (this.isWarehouseSelected) {
				const warehouseId = this.selectedWarehouse?._id ?? null;
				if (warehouseId !== null) {
					store.shipping.origin.warehouse_id = warehouseId;
				}

				const isWarehouseOfficial = this.selectedWarehouse?.is_official ?? false;
				if (isWarehouseOfficial) {
					store.shipping.is_warehouse_official = true;
				}

				return;
			}

			const cb = () => {
				this.setStoreShippingProvince(province);
				this.setStoreShippingCity(city);
				this.setStoreShippingSubdistrict(subdistrict);
				// onSuccess();
			};
			const errorCb = () => {
				this.$notify({
					group: 'productCreator',
					text: 'Maaf terjadi kesalahan, silahkan dicoba kembali.',
					type: 'error',
				});
			};
			userApi.updateStore(store, cb, errorCb);
		},
		onQuantityMinInput(event) {
			const min = event.target.value;
			const minParsed = parseInt(min);
			const maxParsed = parseInt(this.selectedField.value.max);
			const defaultParsed = parseInt(this.selectedField.value.default);
			if (defaultParsed < minParsed) {
				this.selectedField.value.default = min;
			}
			if (minParsed > maxParsed) {
				this.selectedField.value.max = min;
			}
		},
		onQuantityMaxInput(event) {
			const max = event.target.value;
			const maxParsed = parseInt(max);
			const minParsed = parseInt(this.selectedField.value.min);
			const defaultParsed = parseInt(this.selectedField.value.default);
			if (defaultParsed > maxParsed) {
				this.selectedField.value.default = max;
			}
			if (minParsed > maxParsed) {
				this.selectedField.value.min = max;
			}
		},
		onQuantityMinChange(event) {
			const min = event.target.value;
			if (min.trim() === '') {
				this.selectedField.value.min = 1;
			}
		},
		onQuantityMaxChange(event) {
			const max = event.target.value;
			if (max.trim() === '') {
				this.selectedField.value.max = 99;
			}
		},
		onQuantityDefaultChange(event) {
			const defaultValue = event.target.value;
			if (defaultValue.trim() === '') {
				this.selectedField.value.default = this.selectedField.value.min;
			}
		},
		onFieldChange(field) {
			if (!field.enabled && field.name === 'province') {
				// Disable City
				const city = this.fields.find(field => field.name === 'city');
				city.enabled = false;
				// Disable District
				const district = this.fields.find(field => field.name === 'district');
				district.enabled = false;
			} else if (!field.enabled && field.name === 'city') {
				// Disable District
				const district = this.fields.find(field => field.name === 'district');
				district.enabled = false;
			} else if (field.enabled && field.name === 'city') {
				// Enable Province
				const province = this.fields.find(field => field.name === 'province');
				province.enabled = true;
			} else if (field.enabled && field.name === 'district') {
				// Enable Province
				const province = this.fields.find(field => field.name === 'province');
				province.enabled = true;
				// Enable City
				const city = this.fields.find(field => field.name === 'city');
				city.enabled = true;
			}

			if (field.enabled && field.name === 'complete_district') {
				// Disable Province
				const province = this.fields.find(field => field.name === 'province');
				province.enabled = false;
				// Disable City
				const city = this.fields.find(field => field.name === 'city');
				city.enabled = false;
				// Disable District
				const district = this.fields.find(field => field.name === 'district');
				district.enabled = false;
			} else if (
				field.enabled
				&& (field.name === 'province'
					|| field.name === 'city'
					|| field.name === 'district')
			) {
				// Disable Complete District
				const completeDistrict = this.fields.find(
					field => field.name === 'complete_district',
				);
				completeDistrict.enabled = false;
			}
		},
		onVariationPricesChange(prices) {
			this.product.variations.prices = prices;
			this.setProductPrices(duplicateVar(prices));
			this.validateVariableWeight(this.product.variations.prices);
			this.validateVariableEnabled(this.product.variations.prices);
		},
		validateVariableWeight(variation) {
			const step = 'product';
			const key = 'weight';
			this.variationWeightError = [];
			variation.forEach((item, index) => {
				if (item.weight <= 0) {
					const error = this.getErrorMessage(step, key);
					const stepError = { step, key, error };
					this.addStepError(stepError);
					this.variationWeightError[index] = true;
				} else {
					this.variationWeightError[index] = false;
				}
			});

			if (this.variationWeightError.every(value => value === false)) {
				this.removeStepError({ step, key });
			}
		},
		validateVariableEnabled(variations) {
			const step = 'product';
			const key = 'variationEnabled';
			this.variationEnabledError = false;
			const countEnabled = variations.filter(item => item.enabled || typeof item.enabled === 'undefined');

			if (countEnabled.length <= 0) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
				this.variationEnabledError = true;
			} else {
				this.removeStepError({ step, key });
				this.variationEnabledError = false;
			}
		},
		onWeightChange(event) {
			const weight = event.target.value;
			if (weight.trim() === '') {
				this.product.weight = 0;
			} else {
				this.product.weight = parseInt(weight);
			}
		},
		onShippingFlatChange(event) {
			const defaultValue = event.target.value;
			if (defaultValue.trim() === '') {
				this.shipping.flatPrice = 0;
			}
		},
		checkCapabilities() {
			const cantCreateProduct =
				this.isCreateProduct && !this.isUserCan('product_add');
			const cantEditProduct =
				this.isEditProduct && !this.isUserCan('product_edit');
			if (cantCreateProduct || cantEditProduct) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		fetchMembers() {
			this.isFetchingMembers = true;
			const params = {
				limit: 100,
				sort_by: 'name',
				sort: 'asc',
				page: 1,
				keyword: '',
			};
			const callback = (response) => {
				const items = response.data;
				this.members = items;
				this.isFetchingMembers = false;
			};
			const errorCallback = () => {
				this.isFetchingMembers = false;
			};
			teamApi.getMembers(params, callback, errorCallback);
		},
		fetchSuppliers(keyword) {
			this.isSearchSupplier = true;
			const params = {
				sort_by: 'created_at',
				sort: 'desc',
				page: 1,
				keyword,
				role: 'owner',
				owner_type: 'supplier', // supplier
			};

			const callback = (response) => {
				let suppliers = response.data;

				if (suppliers.length > 0) {
					suppliers = suppliers.map((data) => {
						const newObj = {
							...data,
						};
						newObj.businessName = data.store?.name || '';
						newObj.code = data?.code || '';
						newObj.label = data.name && data.email ? `${data.name} - ${data.email}` : '';
						newObj.features = data?.features ?? [];
						return newObj;
					});
					this.supplierOptions = suppliers;
				}

				const optionSupplier = suppliers?.find(curr => curr?._id === this.productDetails?.user_id);
				this.isSearchSupplier = false;
				if (optionSupplier) {
					this.selectedSupplier = {
						...optionSupplier,
						label: `${optionSupplier?.name} - ${optionSupplier?.email}`,
					};
				}

				// this.suppliers = suppliers;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				this.$notify({
					group: 'productCreator',
					title: 'Fetch Suppliers',
					text: msg,
					type: 'error',
				});
			};
			userApi.getUsers(params, callback, errorCallback);
		},
		fetchBelongsTo() {
			this.isFetchingBelongsTo = true;
			const callback = (response) => {
				const data = response.data;
				const belongsTo = data.belongs_to;
				const orderDistribution = data.order_distribution;
				if (!orderDistribution.team_members) {
					orderDistribution.team_members = [];
				}

				this.belongsToMembers = belongsTo;
				this.orderDistribution = orderDistribution;

				this.oldOrderDistribution = duplicateVar(orderDistribution);

				this.isFetchingBelongsTo = false;
			};
			const errorCallback = () => {
				this.isFetchingBelongsTo = false;
			};

			if (this.productId && this.productId !== '') {
				productsApi.getBelongsTo(this.productId, callback, errorCallback);
			}
		},
		belongsToLabel({ name, role }) {
			return `${role.toUpperCase()} - ${name}`;
		},
		addBelongsTo(member) {
			if (
				this.belongsToMembers.findIndex(
					currMember => currMember._id === member._id,
				) === -1
			) {
				this.belongsToMembers.push(member);
			}
		},
		selectedCommissionType(data) {
			this.reseller.commission_type = data.value;
		},
		removeBelongsTo(id) {
			const index = this.belongsToMembers.findIndex(
				member => member._id === id,
			);
			if (index !== -1) {
				this.belongsToMembers.splice(index, 1);
			}
		},
		onErrorLinkClick(event) {
			event.preventDefault();
			const id = event.target.getAttribute('data-id');
			const step = event.target.getAttribute('data-step');
			if (step && step !== '' && step !== this.step) {
				this.errorFieldId = id;
				this.changeStep(step);
			} else {
				scrollTo(id);
			}
		},
		bindErrorLinkClick() {
			$('body').on('click', '.error-fix-link', this.onErrorLinkClick);
		},
		unbindErrorLinkClick() {
			$('body').off('click', '.error-fix-link', this.onErrorLinkClick);
		},
		moveField(direction, index) {
			const newIndex = direction === 'up' ? index - 1 : index + 1;
			const temp = this.fields[index];
			this.$set(this.fields, index, this.fields[newIndex]);
			this.$set(this.fields, newIndex, temp);
		},
		showCustomField() {
			const timestamp = this.moment().valueOf();
			const customField = duplicateVar(defaultCustomField);
			customField.name += `_${timestamp}`;
			this.customField = customField;
			this.isShowCustomField = true;
		},
		onShippingMarkupChange(event) {
			const value = event.target.value;
			if (value.trim() === '') {
				this.shipping.markup = 0;
			}
		},
		addWholesale() {
			if (this.product.wholesale.length === 0) {
				const maxItems = 5;
				for (let index = 0; index < maxItems; index++) {
					this.product.wholesale.push(duplicateVar(defaultWholesaleItem));
				}
			}
		},
		clearWholesale() {
			this.product.wholesale = [];
			// Temp Fix until BE fix the empty array wholesale not updated
			// const emptyWholesales = [];
			// const maxItems = 5;
			// for (let index = 0; index < maxItems; index++) {
			// 	emptyWholesales.push(duplicateVar(defaultWholesaleItem));
			// }
			// this.product.wholesale = emptyWholesales;
			this.isSimpleWholesaleError = false;
		},
		onCategoryChange(category) {
			if (category.type === 'category') {
				this.product.category.category = category.name;
				this.product.category.category_slug = category.slug;
			} else if (category.type === 'sub_category') {
				this.product.category.sub_category = category.name;
				this.product.category.sub_category_slug = category.slug;
			} else if (category.type === 'sub_sub_category') {
				this.product.category.sub_sub_category = category.name;
				this.product.category.sub_sub_category_slug = category.slug;
			}
			this.validateProductCategory(this.product.category.category);
		},

		/**
		 * Show adjust stock popup
		 *
		 * @param {number} quantity Stock Quantity
		 * @param {string} [variation] the variation name whose stock you want to change.
		 */
		showAdjustStock(quantity, variation, type = 'catalog') {
			this.stockQty = quantity;
			this.stockUpdateType = StockUpdate.TYPE_SYNC;
			this.stockType = type;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
		},

		showAddStock(variation, type = 'catalog') {
			this.stockUpdateType = StockUpdate.TYPE_INCREASE;
			this.stockType = type;
			this.stockQty = 0;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
		},

		showReduceStock(variation, type = 'catalog') {
			this.stockUpdateType = StockUpdate.TYPE_DECREASE;
			this.stockType = type;
			this.stockQty = 0;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
		},

		stockInputValidation() {
			if (this.stockQty < 0) {
				this.stockQty = 0;
			} else {
				this.stockQty = this.parsePricing(this.stockQty);
			}
		},

		/**
		 * Update Product Stock
		 *
		 * @param {string} productId Product ID
		 * @param {'increase' | 'decrease' | 'sync'} type Type of stock update
		 * @param {number} quantity Stock quantity
		 * @param {string} description Stock change description
		 * @param {string} [variation] Variation name
		 */
		updateStock(productId, type, quantity, description, variation) {
			this.isUpdatingStock = true;
			const params = {
				type,
				quantity,
				description,
				stock_type: this.stockType,
			};
			if (variation) {
				params.variation = variation;
			}
			const callback = (response) => {
				if (variation) {
					const variationsPrices = response.data.variations.prices;
					this.updateVariationPricesStock(variationsPrices);
				} else {
					const stock = response.data.stock;
					if (stock) {
						if (this.stockType === 'wholesale') {
							this.distributor.stock.quantity = stock.quantity;
						} else {
							this.product.stock.quantity = stock.quantity;
						}
					}
				}

				this.isUpdatingStock = false;

				this.$notify({
					group: 'productCreator',
					text: 'Stock successfully updated.',
					type: 'success',
				});

				this.resetStockUpdate();

				// Hide popup
				this.isShowUpdateStock = false;
				this.validateProductStock();
			};
			const errorCallback = () => {
				this.isUpdatingStock = false;
				this.$notify({
					group: 'productCreator',
					text: 'Stock update occurred an error, please try again.',
					type: 'danger',
				});
			};
			productsApi.updateStock(productId, params, callback, errorCallback);
		},

		/**
		 * Reset stock update value
		 */
		resetStockUpdate() {
			this.stockQty = 0;
			this.stockDescription = '';
			this.stockVariation = null;
		},

		/**
		 * Update Variation Prices Stock
		 * @param {VariationPrice[]} prices Variations Prices
		 */
		updateVariationPricesStock(prices) {
			for (
				let index = 0;
				index < this.product.variations.prices.length;
				index++
			) {
				const variationPrice = this.product.variations.prices[index];
				const sameNameIndex = prices.findIndex(
					price => price.name === variationPrice.name,
				);
				if (sameNameIndex !== -1) {
					const price = prices[sameNameIndex];
					this.product.variations.prices[index].stock.quantity =
						price.stock.quantity;
				}
			}
		},

		isNewVariation(variation) {
			const prices = this.productDetails.variations.prices;
			const variations = prices.filter((price) => {
				const hasIdProperty = Object.prototype.hasOwnProperty.call(price, 'id');
				const property = hasIdProperty ? 'id' : 'name';
				return price[property] === variation[property];
			});

			return variations.length === 0;
		},

		openSettings() {
			this.isSettingsVisible = true;
		},

		fetchCollections() {
			const params = {
				page: 1,
				limit: 100,
				sort_by: 'name',
				sort: 'asc',
			};
			const callback = (response) => {
				const items = response.data;
				this.collections = items;
			};
			const errorCallback = () => {};
			collectionsApi.getList(params, callback, errorCallback);
		},

		addCollection(text) {
			const name = text;
			const slug = slugify(name);
			const params = {
				name,
				slug,
			};

			const callback = (response) => {
				const collection = response.data;
				this.collections.push(collection);
				this.productCollections.push(collection);
				// this.$emit('add', item);
				// this.$notify({
				// 	group: 'general',
				// 	title: 'Collection',
				// 	text: 'Successfully created',
				// 	type: 'success',
				// });
				// this.isSaving = false;
				// this.reset();
				// this.close();
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Collection',
					text: message,
				});
			};

			collectionsApi.add(params, callback, errorCallback);
		},

		isPaymentSelected(payment) {
			const index = this.selectedPayments.findIndex(
				({ key }) => key === payment.key,
			);
			return index !== -1;
		},

		setPayments() {
			const options = duplicateVar(this.paymentOptions);
			let payments = this.selectedPayments.map(({ key }) => options.find(option => option.key === key));
			payments = payments.filter(payment => !!payment);
			// Add Disabled Payments
			options.forEach((option) => {
				const index = payments.findIndex(({ key }) => key === option.key);
				const isNotExist = index === -1;
				if (isNotExist) {
					payments.push(option);
				}
			});
			this.availablePaymentOptions = payments;
		},

		editPaymentDescription(payment) {
			this.selectedPayment = payment;
			this.isPaymentMethodDescriptionVisible = true;
		},

		onMethodsDescriptionChange(e) {
			const value = e.target.value;
			if (this.selectedPayment) {
				const method = this.selectedPayment.key;
				this.$set(this.methodsDescriptions, method, value);
			}
		},

		onPaymentSorted() {
			const selected = this.selectedPayments.map(payment => payment.key);
			const selectedPaymentOptions = this.availablePaymentOptions.filter(
				({ key }) => selected.includes(key),
			);
			this.selectedPayments = selectedPaymentOptions;
		},

		setProductErrors() {
			const step = 'product';
			const errors = duplicateVar(this.stepErrors(step));
			this.$set(this, 'productErrors', errors);

			if (this.instantPriceError) {
				const key = this.instantPriceError.key;
				const message = this.instantPriceError.error;
				this.$set(this.productErrors, key, message);
				const stepError = { step, key, error: message };
				this.addStepError(stepError);
			} else {
				delete errors.price;
				this.removeStepError({ step, key: 'price' });
			}

			if (this.resellerCommissionError) {
				const key = this.resellerCommissionError.key;
				const message = this.resellerCommissionError.error;
				this.$set(this.productErrors, key, message);
				const stepError = { step, key, error: message };
				this.addStepError(stepError);
			} else {
				delete errors.reseller;
				this.$set(this, 'productErrors', errors);
				this.removeStepError({ step, key: 'reseller' });
			}
		},
		isVariationOldData(variations) {
			let isOldData = false;
			if (variations.attributes.length > 0) {
				if (variations.attributes[0].object_values === undefined) {
					isOldData = true;
				}
			}
			return isOldData;
		},
		fixProductVariationAttributes(variations) {
			let attributeObjectValues = [];
			let attributes = variations.attributes;
			const tempAttributeValues = variations.attributes.map(
				attribute => attribute.values,
			);

			attributeObjectValues = tempAttributeValues.map(attribute => attribute.map(value => ({ id: this.$uuid.v4(), text: value })));
			attributes = variations.attributes.map((attribute, i) => ({
				name: attribute.name,
				values: attribute.values,
				object_values: attributeObjectValues[i],
			}));
			return attributes;
		},
		generatePriceIdFromVariation(variations, i) {
			let attributeId = this.$uuid.v4();
			const name = variations.prices[i].name;
			const arrName = name.split(this.separatorToken);
			const attributesOptions = variations.attributes.map(
				attribute => attribute.object_values,
			);
			const hasAttributes = attributesOptions.length > 0;

			if (hasAttributes) {
				const arrId = [];
				arrName.forEach((v, i) => {
					const temp = attributesOptions[i].find(x => x.text === v);
					if (temp !== undefined) {
						arrId.push(temp.id);
					}
				});
				attributeId = arrId.join(this.separatorToken);
			}
			return attributeId;
		},
		defaultSelectedPaymentChannels(paymentChannels) {
			return paymentChannels.map(el => el.key);
		},
		getListAllWarehouse() {
			const params = {
				page: 1,
				limit: 100,
				created_by_admin: true,
				is_deleted: false,
			};
			const callback = (response) => {
				const warehouses = response.data;
				this.allWarehouse = warehouses;
				// console.log(this.allWarehouse);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Warehouses',
					text: message,
				});
			};
			warehouseApi.getWarehouses(params, callback, errorCallback);
		},
		assignSelectedWarehouse(warehouseId) {
			if (this.product.stock.warehouse_enabled) {
				if (this.allWarehouse.length !== 0) {
					const selectedWarehouse = this.allWarehouse.find(warehouse => warehouse._id === warehouseId);
					if (selectedWarehouse) {
						this.selectedWarehouse = selectedWarehouse;
					}
				}
			}
		},
		checkCOD(payments) {
			if (!this.isCODEnabled) {
				payments = payments.filter(payment => payment !== 'cod');
			} else {
				const isCodExists = payments.findIndex(payment => payment === 'cod') !== -1;
				if (!isCodExists) {
					payments.push('cod');
				}
			}
			return payments;
		},
		onChangeEnableCOD(value) {
			this.isCODEnabled = value;
		},
		onChangeDistributorPrice(value) {
			this.isDistributorPriceEnabled = value;
			this.distributor.enabled = value;
		},
		onSupplierChange(supplier) {
			this.selectedSupplier = supplier;
			const shipping = supplier?.store?.shipping;
			this.setSupplierDefaultShipping(shipping);
			this.validateSupplier();
		},
		setSupplierDefaultShipping(shipping) {
			if (shipping && !this.isEditProduct) {
				this.shipping.couriers = shipping.couriers.slice();

				// set force enabled couriers to store settings
				const forcedCouriers = shippingCouriers.filter(
					({ force_enabled }) => !!force_enabled, // eslint-disable-line camelcase
				);

				forcedCouriers.forEach((courier) => {
					const courierKey = courier.key;
					if (this.shipping.couriers.indexOf(courierKey) === -1) {
						this.shipping.couriers.push(courierKey);
					}
				});

				// Set Province
				if (this.provinces.length > 0) {
					const provinceId = shipping.origin.province.id;
					this.shipping.province = this.provinces.find(
						province => province.province_id === provinceId,
					);
					this.fetchCities(provinceId);

					const originCity = shipping.origin?.city;
					if (originCity) {
						this.clearCities();
						this.shipping.city = {
							city_id: originCity.id,
							city_name_with_type: originCity.name,
						};

						const originSubdistrict = shipping.origin?.subdistrict;
						if (originSubdistrict) {
							this.clearSubdistricts();
							this.shipping.subdistrict = {
								subdistrict_id: originSubdistrict.id,
								subdistrict_name: originSubdistrict.name,
							};
						}
					}
				}

				this.shipping.phone_1 = shipping.origin.phone_1;
				this.shipping.phone_2 = shipping.origin.phone_2;
				this.shipping.address = shipping.origin.address;
				this.shipping.zip = shipping.origin.zip;
			}
		},
		updateProductStock(product) {
			this.product.stock = product.stock;
			this.product.variations = product.variations;
			this.product.type = product.type;
		},
		getTemporaryProductId() {
			if (!this.tempProductId && this.isCreateProduct) {
				const callback = (response) => {
					const tempProductId = response.data?.product_id_string ?? null;
					this.tempProductId = tempProductId;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Temp Product',
						text: message,
					});
				};
				productsApi.getTempProductId(callback, errorCallback);
			}
		},
		validateWarehouse() {
			const step = 'product';
			const key = 'warehouse';
			if (this.isMultiWarehouse && !this.warehouses.length && this.isHasFeature('product_multiwarehouse')) {
				const error = this.getErrorMessage(step, key);
				const stepError = { step, key, error };
				this.addStepError(stepError);
			} else if (this.isFieldError(step, key)) {
				this.removeStepError({ step, key });
			}
		},
		onUomChange(e) {
			const value = parseNumber(e.target.value) < 1 ? 1 : parseNumber(e.target.value);
			this.product.uom.value = value;
		},
		getOstockCommissionValue,
		getOstockVariantCommissionValue,
		checkCommission(product) {
			let isLessThanMinimalCommission = false;
			let commission = 0;
			if (product?.outsource_commission?.type === 'percentage') {
				if (this.product.type === 'simple') {
					commission = this.getOstockCommissionValue(product, product.price);
				} else {
					commission = this.getOstockVariantCommissionValue(product, product.price, this.product);
				}

				if (commission <= 2350) {
					isLessThanMinimalCommission = true;
				}
			} else if (product?.outsource_commission?.value <= 2350) {
				isLessThanMinimalCommission = true;
			}

			return isLessThanMinimalCommission;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isHasStoreAddress: 'isHasStoreAddress',
			isUserCan: 'isUserCan',
			isTester: 'isTester',
			isAdmin: 'isAdmin',
			isSupplier: 'isSupplier',
			bankAccounts: 'bankAccounts',
			currency: 'currency',
			defaultShipping: 'defaultShipping',
			pixelIds: 'pixelIds',
			pixelEvents: 'pixelEvents',
			gtmIds: 'gtmIds',
			isStorefrontActive: 'isStorefrontActive',
			isHasFeature: 'isHasFeature',
			step: 'productCreator/step',
			provinces: 'productCreator/provinces',
			cities: 'productCreator/cities',
			subdistricts: 'productCreator/subdistricts',
			isFetchingProvince: 'productCreator/isFetchingProvince',
			isFetchingCity: 'productCreator/isFetchingCity',
			isFetchingSubdistrict: 'productCreator/isFetchingSubdistrict',
			isCreatingProduct: 'productCreator/isCreatingProduct',
			isUpdatingProduct: 'productCreator/isUpdatingProduct',
			backgroundColors: 'productCreator/backgroundColors',
			buyButtonColors: 'productCreator/buyButtonColors',
			submitActionTypes: 'productCreator/submitActionTypes',
			productData: 'productCreator/productData',
			formData: 'productCreator/formData',
			stepErrors: 'productCreator/stepErrors',
			isFieldError: 'productCreator/isFieldError',
			getErrorMessage: 'productCreator/getErrorMessage',
			isVariableWholesaleError: 'productCreator/isVariableWholesaleError',
			tiers: 'resellerTiers/all',
			productTiers: 'resellerTiers/productTiers',
			commission: 'commission',
			stock: 'productWarehouse/stock',
			warehouses: 'productWarehouse/warehouse',
		}),
		currencySymbol() {
			return this.getCurrencySymbol(this.currency);
		},
		stockTypeLabel() {
			return toTitleCase(this.stockType);
		},
		filteredTiers() {
			const arrayTiers = this.productTiers.map(tier => tier.tier_id);
			return this.tiers.filter(tier => !arrayTiers.includes(tier._id));
		},
		isHasFeaturePrivateOrder() {
			if (this.isAdmin) {
				const supplierFeatures = this.selectedSupplier?.features ?? [];
				return supplierFeatures.includes('private_order') && this.isUserCan('admin_product_action_private_order');
			}
			return this.isHasFeature('private_order');
		},
		checkoutUrlFull() {
			const protocol = 'https';
			const domain = 'ostock.id';
			return `${protocol}://${this.user.username}.${domain}/${this.product.slug}`;
		},
		descriptionLimit() {
			return this.descriptionTreshold - this.product.description.length;
		},
		pixelEventsOptions() {
			return this.pixelEvents.filter(
				pixelEvent => this.pixel.events.indexOf(pixelEvent) === -1,
			);
		},
		salePrice() {
			const salePrice = duplicateVar(this.product.sale_price);
			if (salePrice.schedule.since !== '') {
				let since = this.customFormatter(salePrice.schedule.since);
				since = `${since} 00:00:01`;
				salePrice.schedule.since = since;
			}
			if (salePrice.schedule.until !== '') {
				let until = this.customFormatter(salePrice.schedule.until);
				until = `${until} 23:59:59`;
				salePrice.schedule.until = until;
			}
			return salePrice;
		},
		elements() {
			const header = duplicateVar(this.header);

			const guaranteeSeal = this.guaranteeSeal.enabled
				? this.guaranteeSeal.value
				: '';

			const fields = this.fields.filter(field => field.enabled);

			const buyButton = {
				text: this.buyButton.text,
				background: this.buyButton.color,
			};

			const video = {
				// url: this.videoUrl,
				url: this.product.videos[0] || '', // get from product videos
			};

			const image = {
				enabled: this.product.imageEnabled,
			};

			const description = this.formDescription;

			const coupon = this.coupon;

			const features = this.bulletPoints.slice();

			const testimonials = this.testimonials.slice();

			const footer = {
				orderonline_logo: this.orderonlineLogo,
				links_enabled: false,
				links: [
					// { url: 'https://example.com', label: 'Privacy' },
					// { url: 'https://example2.com', label: 'Policy' },
				],
			};

			const summary = this.summary;

			const sectionTitles = this.sectionTitles;

			const multipleVariations = this.multipleVariations;

			const elements = {
				header,
				guarantee_seals: guaranteeSeal,
				fields,
				buy_button: buyButton,
				video,
				image,
				description,
				coupon,
				features,
				testimonials,
				footer,
				order_summary: summary,
				section_titles: sectionTitles,
				multiple_variations: multipleVariations,
				dropship_enabled: this.dropshipEnabled,
			};

			return elements;
		},
		formParams() {
			const formName = this.form.name;
			const settings = this.form.settings;

			const submitAction = {
				type: this.submitAction.type.key,
				data: {
					url: this.submitAction.url,
					wa_numbers: this.submitAction.waNumbers.slice(),
					header: this.submitAction.header,
					headline: this.submitAction.headline,
					video: this.submitAction.video,
					body_text: this.submitAction.bodyText,
					body_text_cod: this.submitAction.bodyTextCod,
					body_text_instant: this.submitAction.bodyTextInstant,
					purchase_link_enabled: false,
					purchase_url: '',
					purchase_label: '',
					bump_link_enabled: false,
					bump_url: '',
					bump_label: 'Akses disni bump',
				},
			};

			const pixelEvents = this.pixel.events.map(
				pixelEventsFormatter(this.pixelConfigs),
			);
			const successPixelEvents = this.successPixel.events.map(
				pixelEventsFormatter(this.successPixelConfigs),
			);

			const tiktokPixelIds = this.tiktok.ids.slice();
			const tiktokSuccessPixelIds = this.tiktokSuccess.ids.slice();

			const tracking = {
				form: {
					pixel: {
						ids: this.pixel.ids.slice(),
						events: pixelEvents,
					},
					gtm: {
						ids: this.gtm.ids.slice(),
					},
					tiktokPixel: {
						ids: tiktokPixelIds,
					},
				},
				success: {
					pixel: {
						ids: this.successPixel.ids.slice(),
						events: successPixelEvents,
					},
					gtm: {
						ids: this.successGtm.ids.slice(),
					},
					tiktokPixel: {
						ids: tiktokSuccessPixelIds,
					},
				},
			};

			const style = {
				template: this.layout,
				background: this.backgroundColor,
			};

			const elements = Object.assign({}, this.elements);

			const language = this.form.language;

			const form = {
				name: formName,
				submit_action: submitAction,
				tracking,
				style,
				elements,
				language,
				settings,
			};

			return form;
		},
		isWaNumbersValid() {
			const reg = new RegExp(/^\d+$/);
			const isNotEmpty =
				this.submitAction.waNumbers.findIndex(
					number => number.trim() === '',
				) === -1;
			const notEmptyNumbers = this.submitAction.waNumbers.filter(
				number => number.trim() !== '',
			);
			const inValidNumbers = notEmptyNumbers.filter((number) => {
				const isNumber = reg.test(number);
				return !isNumber;
			});
			const isValid = isNotEmpty && inValidNumbers.length === 0;
			return isValid;
		},
		lowestPrice() {
			const type = this.product.type;
			const isVariable = type === 'variable';
			const simplePrice = this.product.price;
			let price = simplePrice;
			const salePrice = this.salePrice;

			if (salePrice && salePrice.enabled) {
				price = salePrice.price;
			}

			if (isVariable) {
				const prices = this?.product?.variations?.prices ?? [];
				if (prices.length > 0) {
					const pricesValues = prices.map(({ price }) => price);
					const lowestPrice = Math.min(...pricesValues);
					price = lowestPrice;
				}
			}

			price = parseInt(price);

			return price;
		},
		instantPriceError() {
			let stepError = null;
			const payments = this.selectedPayments.map(payment => payment.key).sort();
			const isHasIntant = payments.includes('instant');
			const price = this.lowestPrice;
			const isPriceLow = price < 1000;
			if (((isHasIntant && isPriceLow) || this.product.price <= 0) && this.product.type !== 'variable') {
				const step = 'product';
				const key = 'price';
				const errorMessage = this.getErrorMessage(step, 'price_instant');
				stepError = { step, key, error: errorMessage };
			}
			return stepError;
		},
		biggestCommission() {
			let commission = 0;

			const productTiers = this.productTiers || [];
			for (let index = 0; index < productTiers.length; index++) {
				const productTier = productTiers[index];
				if (productTier.discount_type === 'nominal') {
					const currentCommission = parseInt(productTier.discount_value);
					if (currentCommission > commission) {
						commission = currentCommission;
					}
				}
			}

			return commission;
		},
		maxCommission() {
			const lowestPrice = this.lowestPrice;
			const minimalMargin = lowestPrice * (10 / 100);
			const maxCommission = lowestPrice - minimalMargin;
			return maxCommission;
		},

		commissionFee() {
			return this.lowestPrice * (this.commission / 100);
		},

		resellerCommissionError() {
			let stepError = null;
			// const lowestPrice = this.lowestPrice;
			// const minimalMargin = lowestPrice * (10 / 100);
			const biggestCommission = this.biggestCommission;
			const isResellerEnabled = this.reseller && this.reseller.enabled;
			const isOverrideTiers = this.productTiers && this.productTiers.length > 0;
			const isCommissionError =
				isResellerEnabled
				&& isOverrideTiers
				&& biggestCommission > this.maxCommission;
			if (isCommissionError) {
				const step = 'product';
				const key = 'reseller';
				const errorMessage = this.getErrorMessage(step, 'reseller');
				stepError = { step, key, error: errorMessage };
			}
			return stepError;
		},
		productErrorsList() {
			const errorsList = [];
			const keys = this.productErrors ? Object.keys(this.productErrors) : [];
			for (let index = 0; index < keys.length; index++) {
				const key = keys[index];
				const productError = this.productErrors[key];
				const errorItem = { key, message: productError };
				errorsList.push(errorItem);
			}
			return errorsList;
		},
		productId() {
			return this.$route.params.id;
		},
		isCreateProduct() {
			return this.entity === 'product' && this.action === 'create';
		},
		isEditProduct() {
			return this.entity === 'product' && this.action === 'edit';
		},
		isCreateForm() {
			return this.entity === 'form' && this.action === 'create';
		},
		isEditForm() {
			return this.entity === 'form' && this.action === 'edit';
		},
		isUpdateDefaultShipping() {
			const isShippingSelected =
				this.shipping.province
				&& this.shipping.city
				&& this.shipping.subdistrict;
			// const isProvinceNotSet =
			// 	this.user && this.user.store.shipping.origin.province.id === 0;
			// const isSubdistrictNotSet =
			// 	this.user && this.user.store.shipping.origin.subdistrict.id === 0;
			// const isOriginNotSet = isProvinceNotSet || isSubdistrictNotSet;
			const isAddressSet =
				this.shipping.phone_1 !== ''
				&& this.shipping.phone_2 !== ''
				&& this.shipping.address !== ''
				&& this.shipping.zip !== '';

			return isShippingSelected && isAddressSet;
		},
		isProductReady() {
			const isReady =
				this.isCreateProduct
				|| this.isCreateForm
				|| ((this.isEditProduct || this.isEditForm) && this.productDetails);
			return isReady;
		},
		isShippingAutomated() {
			return this.shipping.flat === false && this.shipping.free === false;
		},
		isShippingFlat() {
			return this.shipping.flat === true && this.shipping.free === false;
		},
		isShippingFree() {
			return this.shipping.flat === false && this.shipping.free === true;
		},
		isAdmin() {
			return this.user && this.user.is_admin;
		},
		membersCS() {
			return this.members.filter(member => member.role === 'cs');
		},
		belongsToMembersCS() {
			return this.belongsToMembers.filter(member => member.role === 'cs');
		},
		productPrice() {
			return this.product.sale_price.enabled
				? this.product.sale_price.price
				: this.product.price;
		},
		isCODSelected() {
			return (
				this.selectedPayments.findIndex(payment => payment.key === 'cod') !== -1
			);
		},
		isInstantSelected() {
			return (
				this.selectedPayments.findIndex(
					payment => payment.key === 'instant',
				) !== -1
			);
		},
		isSubdistrictFieldActive() {
			const filter = field => (field.name === 'district' || field.name === 'complete_district')
				&& field.enabled;
			const subdistrictFields = this.fields.filter(filter);
			return subdistrictFields.length > 0;
		},
		payments() {
			// const payments = this.selectedPayments.map(payment => payment.key).sort();
			const selected = this.selectedPayments.map(payment => payment.key);
			const selectedPaymentOptions = this.availablePaymentOptions.filter(
				({ key }) => selected.includes(key),
			);
			let payments = selectedPaymentOptions.map(({ key }) => key);
			payments = this.checkCOD(payments);
			return payments;
		},
		canHideLogo() {
			const allowedPlans = ['professional_2', 'business_2', 'enterprise_2'];
			const plan = this.user.package;
			return allowedPlans.includes(plan);
		},
		isHasProduct() {
			return this.productId;
		},
		getProductSuspendNote() {
			let note = '-';

			if (this.productDetails !== null) {
				note = this.productDetails.suspend_note;
			}

			return note;
		},
		isWarehouseEnabled() {
			return this.product.stock.warehouse_enabled;
		},
		isWarehouseSelected() {
			return this.isWarehouseEnabled && this.selectedWarehouse !== null;
		},
		backUrl() {
			const adminProducts = {
				path: '/admin/products',
				name: 'adminProducts',
			};
			const products = {
				path: '/products',
				name: 'products',
			};
			return this.isAdmin ? adminProducts : products;
		},
		isMultiWarehouse() {
			return (
				// eslint-disable-next-line camelcase
				(this?.product?.stock?.multi_warehouse && this.product.stock.multi_warehouse) ?? false
			);
		},
		isNewInventoryVisible() {
			// temporary visible only to specified user
			const isVisible = this.isHasFeature('product_multiwarehouse');
			return isVisible;
		},
		attributesCombinationCount() {
			if (this.product.type !== 'variable') {
				return 0;
			}

			const attributes = this.product?.variations?.attributes || [];
			const totalCount = attributes.reduce((total, attribute) => total * (attribute?.values?.length || 0), 1);

			return totalCount;
		},
		activeVariationsCount() {
			if (this.product.type !== 'variable') {
				return 0;
			}

			const variations = this.product?.variations?.prices || [];
			const totalCount = variations.reduce((count, variant) => {
				const existsCondition = typeof variant.enabled !== 'undefined' && variant.enabled;
				const notExistsCondition = typeof variant.enabled === 'undefined';
				return count + (existsCondition || notExistsCondition ? 1 : 0);
			}, 0);

			return totalCount;
		},
		isInactiveVariationExists() {
			return this.attributesCombinationCount !== this.activeVariationsCount;
		},
	},
	watch: {
		user() {
			if (this.isAdmin) {
				document.body.classList.add('is-grey');
			}
			this.checkCapabilities();
			// this.setDefaultShipping();
			// Fetch Provinces
			if (this.provinces.length === 0) {
				this.$store.dispatch('productCreator/fetchProvinces');
			}

			if (this.allWarehouse.length === 0) {
				this.getListAllWarehouse();
			}
		},
		'product.name': function (value) {
			this.validateProductName(value);
		},
		'product.videos': function (value) {
			this.validateVideoURL(value);
		},
		'product.slug': function (slug) {
			slug = slug.trim();
			slug = slug.replace(/ /g, '');
			slug = slug.replace(/\s/g, '');
			slug = slug.replace(/[^\w-]+/g, '');
			this.product.slug = slug;

			if (this.isNewInventoryVisible) {
				this.getTemporaryProductId();
			}

			// slug validation moved to backend
			// if (this.product.slug !== '' && !this.productId) {
			// 	this.validateSlug(this.product.slug);
			// }
		},
		'product.code': function () {
			this.validateProductCode();
		},
		'product.weight': function () {
			this.validateProductWeight();
		},
		// disabled by request
		'product.stock.quantity': function () {
			this.validateProductStock();
		},
		provinces() {
			if (this.productData && this.shipping.province === null) {
				const provinceId = this.productData.shipping.origin.province_id;
				// eslint-disable-next-line
				const province = this.provinces.find(
					province => province.province_id === provinceId,
				);
				if (province) {
					this.shipping.province = province;
					this.fetchCities(provinceId);
				}
			} else {
				this.setDefaultShipping();
			}
		},
		cities() {
			if (this.cities.length === 0) {
				return;
			}
			// if (this.productData && this.shipping.city === null) {
			if (this.productData) {
				const isFromCity = this.productData.shipping.origin.type === 'city';
				const cityId = isFromCity
					? this.productData.shipping.origin.id
					: this.productData.shipping.origin.city_id;
				// eslint-disable-next-line
				const city = this.cities.find(city => city.city_id == cityId);
				if (city) {
					this.shipping.city = city;
					this.fetchSubdistricts(cityId);
				}
			} else if (this.defaultShipping) {
				const cityId = this.defaultShipping.origin.city.id;
				// eslint-disable-next-line
				const city = this.cities.find(city => city.city_id == cityId);
				if (city) {
					this.shipping.city = city;
					this.fetchSubdistricts(cityId);
				}
			}
		},
		subdistricts() {
			if (this.subdistricts.length === 0) {
				return;
			}
			// if (this.productData && this.shipping.subdistrict === null) {
			if (this.productData) {
				const subdistrictId = this.productData.shipping.origin.subdistrict_id;
				if (subdistrictId) {
					// eslint-disable-next-line
					const subdistrict = this.subdistricts.find(
						subdistrict => subdistrict.subdistrict_id === subdistrictId,
					);
					if (subdistrict) {
						this.shipping.subdistrict = subdistrict;
					}
				}
			} else if (this.defaultShipping) {
				const subdistrictId =
					this.defaultShipping.origin.subdistrict
					&& this.defaultShipping.origin.subdistrict.id;
				if (subdistrictId) {
					// eslint-disable-next-line
					const subdistrict = this.subdistricts.find(
						subdistrict => subdistrict.subdistrict_id === subdistrictId,
					);
					if (subdistrict) {
						this.shipping.subdistrict = subdistrict;
					}
				}
			}
		},
		'form.name': function () {
			this.validateFormName();
		},
		'header.title.enabled': function () {
			this.validateTitle();
		},
		'header.title.text': function () {
			this.validateTitle();
		},
		'header.tagline.text': function () {
			this.validateTagline();
		},
		'product.price': function (price) {
			this.calculateInvPrice();
			this.validateProductPrice(price);
		},
		belongsToMembersCS() {
			this.validateSuccessCS();
		},
		productDetails(value) {
			const product = duplicateVar(value);
			this.setProduct(product);
			this.setProductData(product);

			// Fetch Form Details
			const formId = this.isEditForm
				? this.formId
				: product.traffic_distribution.forms[0].form_id.$oid;
			if ((this.isEditProduct || this.isEditForm) && formId) {
				this.fetchFormDetails(formId);
			}
		},
		formDetails(value) {
			const form = duplicateVar(value);
			this.setForm(form);
			this.setFormData(form);
		},
		members(members) {
			if (this.productDetails && this.productDetails.belongs_to) {
				// Belongs To
				const filter = member => this.productDetails.belongs_to.findIndex(
					belong => belong.$oid === member._id,
				) !== -1;
				const belongsTo = members.filter(filter);
				this.belongsToMembers = belongsTo;
			}
		},
		step() {
			if (this.errorFieldId !== '') {
				setTimeout(() => {
					scrollTo(this.errorFieldId);
					this.errorFieldId = '';
				}, 400);
			}
		},
		collections() {
			// Set Product Collections
			if (
				this.productData
				&& this.productData.collections
				&& this.collections.length > 0
			) {
				const collections = this.productData.collections;
				const selectedCollections = this.collections.filter(({ slug }) => collections.includes(slug));
				this.productCollections = selectedCollections;
			}
		},
		instantPriceError() {
			this.setProductErrors();
		},
		resellerCommissionError() {
			this.setProductErrors();
		},
		'shipping.couriers': function (value) {
			this.codShippingCouriers = value;
		},
		allWarehouse() {
			if (this.selectedWarehouseId && !this.selectedWarehouse) {
				this.assignSelectedWarehouse(this.selectedWarehouseId);
			}
		},
	},
	created() {
		document.body.classList.add('is-grey');
		this.setPayments();

		// this.reset();
		this.resetShipping();

		// Fetch Members
		this.fetchMembers();

		// Fetch Belongs To
		this.fetchBelongsTo();

		// Reset Step Errors
		this.resetStepErrors();

		// Reset Collections
		this.productCollections = [];

		// Fetch Collections
		this.fetchCollections();

		// Shipping
		if (this.user) {
			this.checkCapabilities();
			// Fetch Provinces
			if (this.provinces.length === 0) {
				this.$store.dispatch('productCreator/fetchProvinces');
			}

			if (this.allWarehouse.length === 0) {
				this.getListAllWarehouse();
			}
		}

		if (this.productId) {
			// Fetch product details
			this.fetchProductDetails(this.productId);
		}

		if (this.isEditProduct) {
			// Change step
			this.changeStep('product');
		}

		this.bindErrorLinkClick();
	},
	destroyed() {
		document.body.classList.remove('is-grey');
		this.unbindErrorLinkClick();
	},
	unmounted() {
		this.setProductPrices([]);
	},
};
</script>

<style lang="scss" scoped>
.error-messages {
	display: block;
	font-size: 0.75em;
	color: red;
}

.info-pcs {
	font-size: 14px;
	font-weight: 400;
	line-height: 22px;
	text-align: left;
	color: #414756A6
}

.upload-image-container {
	display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
	gap: 12px;

	& > .image-wrapper {
		width: 100%;
		aspect-ratio: 1;
	}
}

@media screen and (max-width: 1199px) {
	.pc-image-empty .image-upload-placeholder .text-placeholder {
		padding-top: 0;
	}
	.pc-image-empty .image-upload-placeholder .image-placeholder {
		font-size: 18px;
	}
	.pc-image-empty .image-upload-placeholder .text-placeholder {
		font-size: 14px;
	}
}

@media screen and (max-width: 767px) {
	.pc-image-empty .image-upload-placeholder .image-placeholder {
		font-size: 16px;
	}
	.pc-image-empty .image-upload-placeholder .text-placeholder {
		font-size: 10px;
	}
	.upload-image-container {
		gap: 8px;
	}
}

@media (min-width: 576px) and (max-width: 767px) {
	.upload-image-container {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
</style>

<style lang="scss">
.page-product-creator {
	.error {
		.multiselect__tags {
			border-color: red;
		}
	}
}
</style>
